<template>
	<div class="create-container">
		<div class="create-host" v-if="creatVisibile">
			<div class="jc-page-header">
				<div class="jc-container">
					<el-page-header show-back-icon :title="$t('create.text.makeCps')" @back="jump_to_up()" >
						<template slot="content">
							<div class="jc-list__header--right">
								<a :href="Config.BUY_HELP_URL" target="_blank" class="fr buy-info">
									{{$t('create.text.buyMustKnow')}}
								</a>
							</div>
						</template>
					</el-page-header>
				</div>
			</div>
			<div class="jc-page-content">
				<div class="jc-container pr">
					<div class="buildTab">
						<ul>
							<li id="tab1" @click="setTab('tab',1,2)" class="hover">
								{{$t('create.text.yearlyOrMonthly')}}
								<div class="jc-badge-discount">{{$t('create.text.sale')}}</div>
							</li>
							<li id="tab2" @click="setTab('tab',2,2)" v-if="isVip">
								{{ $t('create.text.byConfigurations') }}
							</li>
						</ul>
					</div>
				  	<div class="buildCon" id="con-tab-1">
						<div class="infoBox">
							<!-- 地域与可用区 -->
							<div class="jc-page-card">
								<div class="jc-page-card-header">
								  	<h3 class="jc-page-card-title">{{$t('create.text.regionAndAz')}}</h3>
								</div>
								<el-form class="jc-form cps-create-form" label-width="130px">
									<el-form-item :label="$t('create.text.region') | withColon">
										<el-radio-group
											v-model="selectedRegion"
											@change="regionChange">
										  	<el-radio-button v-for="(regionName,region,index) in regions" :key="index" :label="region">
												{{regionName}}
										  	</el-radio-button>
										</el-radio-group>
										<el-tooltip effect="dark" class="ml10" placement="right">
										  	<div slot="content" class="my-os-disk-tip">{{$t('create.tooltip.region')}}
										  	</div>
										  	<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
									</el-form-item>
									<el-form-item :label="$t('create.text.az') | withColon">
										<el-radio-group v-model="selectedZone" @change="zoneChange">
											<el-radio-button
												v-for="(azName,az,index) in zones[selectedRegion]"
												:key="index" :label="az">
												{{azName}}
											</el-radio-button>
										</el-radio-group>
										<el-tooltip effect="dark" class="ml10" placement="right">
											<div slot="content" class="my-os-disk-tip">{{$t('create.tooltip.az')}}</div>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
									</el-form-item>
								</el-form>
							</div>
							<!-- 规格 -->
							<div class="jc-page-card">
								<div class="jc-page-card-header">
								  	<h3 class="jc-page-card-title">{{$t('create.text.spec')}}</h3>
								</div>
								<el-form class="jc-form cps-create-form" label-width="130px" style="width: 90%;margin-left: 0px;">
									<el-form-item :label="$t('create.text.series') | withColon">
										<el-radio-group v-model="selectedSeries" @change="changeSeries">
											<el-radio-button
												v-for="(series) in Object.keys(deviceTypesTable)"
												:key="series" :label="series">{{seriesMap[series]}}
											</el-radio-button>
										</el-radio-group>
									</el-form-item>
									<div class="select-type" style="width: 830px;">
										<div class="search-label"><span>{{$t('detail.text.spec') | withColon}}</span></div>
										<el-input
											v-model="searchType"
											:placeholder="$t('retailInstance.text.example')"
											@keyup.enter.native="handleIconClick()"
											class="search-input"></el-input>
										<el-button
											type="primary"
											class="search-icon"
											@click="handleIconClick()">{{$t('retailInstance.text.search')}}</el-button>
									</div>
								  <el-form-item>
									<div class="jc-form-box">
									  <div style="overflow:hidden;margin-right:-30px;width: 830px">
										<el-table :data="deviceTypesTable[selectedSeries]"
												  class="instance-type"
                                                  style="width: 100%;"
												  :empty-text="$t('retailInstance.text.empty')"
												  border>
										  <!-- 规格类型 -->
										  <el-table-column min-width="330" prop="name"
														   :label="$t('create.text.specType')">
											<template slot-scope="scope">
											  <el-radio-group v-if="!deviceTypesNum[scope.row.deviceType]"
															  :disabled="!deviceTypesNum[scope.row.deviceType] || isCalculatIng || isConfigurationsCalculatIng"
															  v-model="selectedStandard"
															  @click="selectStandard(scope.row.deviceType)">
												<el-radio :label="scope.row.deviceType">
												  <span v-html="isIncludeBra(scope.row.name)"></span>
												</el-radio>
											  </el-radio-group>
											  <el-tooltip placement="bottom-start"
														  v-if="!deviceTypesNum[scope.row.deviceType]">
												<span class="sold-out">{{$t('create.text.soldOut')}}</span>
												<div slot="content" class="my-app-tip" style="max-width:200px;">
												  <span
													v-if="selectedHostNumber >1 && !deviceTypesNum[scope.row.deviceType]">
													{{$t('create.tooltip.notEnough')}}</span>
												  <span v-else>{{$t('create.tooltip.soldOut')}}</span>
												  {{$t('create.tooltip.cusService')}}
												  <a v-bind:href="Config.WORK_URL" target="_blank" style="color:#2C68FF">
													{{$t('create.tooltip.ticket')}}
												  </a>
												</div>
											  </el-tooltip>
											  <el-radio-group v-else
															  :disabled="!deviceTypesNum[scope.row.deviceType] || isCalculatIng || isConfigurationsCalculatIng"
															  v-model="selectedStandard"
															  @click="selectStandard(scope.row.deviceType)">
												<el-radio :label="scope.row.deviceType">{{scope.row.name}}
												</el-radio>
											  </el-radio-group>
											</template>
										  </el-table-column>
										  <!-- 规格 -->
										  <el-table-column min-width="300" prop="deviceType"
														   :label="$t('create.text.spec')">
											<template slot-scope="scope">
											  <span :title="scope.row.deviceType">
												{{scope.row.deviceType}}
											  </span>
											</template>
										  </el-table-column>
										  <!-- CPU -->
										  <el-table-column prop="cpuDetail" min-width="200"
														   :label="$t('create.text.cpu')">
											<template slot-scope="scope">
											  <span :title="scope.row.cpuDetail">
												{{scope.row.cpuDetail}}
											  </span>
											</template>
										  </el-table-column>
										  <!-- 内存 -->
										  <el-table-column prop="memConcise" min-width="75"
														   :label="$t('create.text.memory')">
											<template slot-scope="scope">
											  <span :title="scope.row.memDetail">
												{{scope.row.memDetail}}
											  </span>
											</template>
										  </el-table-column>
										  <!-- 网卡 -->
										  <el-table-column prop="ifConcise" min-width="130"
														   :label="$t('create.text.netCard')">
											<template slot-scope="scope">
											  <span>{{scope.row.ifConcise}}</span>
											</template>
										  </el-table-column>
										  <!-- GPU -->
										  <el-table-column prop="gpuConcise" min-width="90"
														   :label="$t('create.text.gpu')">
											<template slot-scope="scope">
											  <span>{{scope.row.gpuConcise | maybeEmpty}}</span>
											</template>
										  </el-table-column>
										</el-table>
									  </div>
									</div>
									<p>{{$t('create.text.currentDeviceType')}}
									  <span class="cff96">
										{{currentDeviceType}}
									  </span>
									  {{currentDeviceTypeDetail}}
									</p>
									<p class="el-form-item-help custom-margin-top">
									  {{$t('create.help.spec')}}
									  <a v-bind:href="Config.TYPE_HELP_URL" target="_blank">
										{{$t('create.help.detail')}}
									  </a>
									</p>
								  </el-form-item>
								</el-form>
							</div>
							<!-- 镜像 -->
							<div class="jc-page-card" id="imgType">
								<div class="jc-page-card-header">
									<h3 class="jc-page-card-title">{{$t('create.text.mirror')}}</h3>
								</div>
								<el-form class="jc-form cps-create-form" label-width="130px"
									:model="ruleFormType"
									:rules="rulesType"
									ref="ruleFormType">
									<!-- 镜像类型 -->
									<el-form-item :label="$t('create.text.mirrorType') | withColon">
                                        <span v-if="!imageTypes.length">--</span>
										<el-radio-group v-model="selectedImageType" v-else>
										  	<el-radio-button
										  		v-for="(item,key,index) in imageTypes"
										  		:key="index"
												:label="key">{{item.sourceName}}
										  	</el-radio-button>
										</el-radio-group>
									</el-form-item>
									<!-- 操作系统 -->
									<el-form-item :label="$t('create.text.os') | withColon">
                                        <span v-if="!showOsTypes">--</span>
										<el-radio-group v-model="selectedOS" v-else>
										  	<el-radio-button v-for="(item,key,index) in osTypes"
										  		:key="index"
												:label="key">
											</el-radio-button>
										</el-radio-group>
									</el-form-item>
									<!-- 系统版本 -->
									<el-form-item
										:label="$t('create.text.osVersion') | withColon"
										ref="osVersion" required
										prop="type"
										:show-message="false">
										<el-select v-model="selectedOSTypeId"
											:placeholder="$t('create.placeholder.version')">
										  	<el-option v-for="item in osTypes[selectedOS]" :key="item.osTypeId"
												:label="item.osName"
												:value="item.osTypeId">
											</el-option>
										</el-select>
									</el-form-item>
								</el-form>
							</div>
							<!-- 存储 -->
							<div class="jc-page-card" id="storage">
								<div class="jc-page-card-header">
									<h3 class="jc-page-card-title">{{$t('create.text.storage')}}</h3>
								</div>
								<el-form class="jc-form cps-create-form" label-width="130px">
									<el-form-item :label="$t('create.text.sysDisk') | withColon">
										<span>{{selectedSysRaidName | maybeEmpty}}</span>
										<el-tooltip class="ml10" effect="dark" placement="right"
											content="Right Top">
											<div slot="content" class="my-os-disk-tip">{{$t('create.tooltip.sysDisk')}}
											</div>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
									</el-form-item>
									<el-form-item :label="$t('create.text.sysDiskCapacity') | withColon">
										<span>{{sysDiskCapacity}}</span>
										<span class="el-form-item-help">{{$t('create.text.sysDiskCapacityUnitTip')}}</span>
									</el-form-item>
									<el-form-item :label="$t('retailInstance.text.systemDataPartitions') | withColon">
										<template v-if="systemType === 'windows'">
											<span>{{$t('retailInstance.text.emptyPartition')}}</span>
										</template>
										<template v-else>
											<el-radio-group v-model="selectedPartitionMode">
												<el-radio v-for="(item,index) in systemDiskPartitionModes" :key="index"
													:label="item.value">
													{{item.label}}
												</el-radio>
											</el-radio-group>
											<el-tooltip class="ml10" effect="dark" placement="right"
												content="Right Top">
												<div slot="content" class="my-os-disk-tip">{{$t('create.tooltip.systemPartition')}}
												</div>
												<a><i class="jc-icon-question"></i></a>
											</el-tooltip>
											<section
												class="defaultPartition"
												v-if="selectedPartitionMode === 'default'"
												v-html="defaultSystemDataPartitions">
											</section>
											<custom-partition
												ref="systemPartition"
												:visible="selectedPartitionMode === 'custom'"
												:region="selectedRegion"
												diskType="system"
												:partitionInfos="systemDataPartitions"
												:otherPartitionInfos="dataDiskPartitions"
												:isCentOS66="isCentOS66"
												:totalDiskSize="systemDiskSize">
											</custom-partition>
										</template>
									</el-form-item>
									<el-form-item :label="$t('create.text.dataDisk') | withColon">
										<template v-if="raids.length">
											<div v-for="(item,key,index) in raids" :key="index"
												@click="selectDataRaid(item)">
												<el-tooltip
													style="margin-left:5px;margin-top:5px" effect="dark"
													placement="bottom-start"
													content="BOTTOM Center">
													<div slot="content" class="my-os-disk-tip data-disk">{{item.description}}
													</div>
													<el-card
														:line=true class="deviceType cps-raid-card"
														v-if="selectedStandard === 'cps.c.perf3'"
														:class="{'selected-box-card':item.raidTypeId == selectedDataRaidId}">
														<div
															slot="header" class="clear-fix"
															:class="{'active-card':item.raidTypeId == selectedDataRaidId}">
															<span class="item text">{{customRaidsNameMap[item.raidType]}}</span>
														</div>
														<el-form>
															<p style="text-align:center;">{{item.volumeDetail}}</p>
														</el-form>
													</el-card>
													<el-card
														:line=true class="deviceType cps-raid-card" v-else
														:class="{'selected-box-card':item.raidTypeId == selectedDataRaidId}">
														<div
															slot="header" class="clear-fix"
															:class="{'active-card':item.raidTypeId == selectedDataRaidId}">
														<span class="item text">{{radisNameMap[item.raidType]}}</span>
														</div>
														<el-form>
															<p style="text-align:center;">{{item.volumeDetail}}</p>
														</el-form>
													</el-card>
												</el-tooltip>
											</div>
										</template>
									  	<span v-else>--</span>
									</el-form-item>
									<el-form-item
										v-if="raids.length"
										:label="$t('create.text.dataDiskCapacity') | withColon">
										<span>{{dataDiskCapacity}}</span>
										<span class="el-form-item-help">{{$t('create.text.sysDiskCapacityUnitTip')}}</span>
									</el-form-item>
									<el-form-item
										:label="$t('retailInstance.text.dataDiskPartition') | withColon"
										v-if="raids.length">
										<template v-if="systemType === 'windows'">
											<span>{{$t('retailInstance.text.emptyPartition')}}</span>
										</template>
										<template v-else>
											<el-radio-group
												v-model="selectedDataDiskPartitionMode">
												<el-radio v-for="(item,index) in dataDiskPartitionModes" :key="index"
													:label="item.value">
													{{item.label}}
												</el-radio>
											</el-radio-group>
											<section
												class="defaultPartition"
												v-if="selectedDataDiskPartitionMode === 'default'"
												v-html="defaultDataDiskPartitions">
											</section>
											<custom-partition
												ref="dataPartition"
												:visible="selectedDataDiskPartitionMode === 'custom'"
												:region="selectedRegion"
												diskType="data"
												:partitionInfos="dataDiskPartitions"
												:otherPartitionInfos="systemDataPartitions"
												:isCentOS66="isCentOS66"
												:totalDiskSize="dataDiskSize">
											</custom-partition>
										</template>
									</el-form-item>
								</el-form>
							</div>
							<!-- 网络 -->
							<div class="jc-page-card">
								<div class="jc-page-card-header">
									<h3 class="jc-page-card-title">{{$t('create.text.net')}}</h3>
								</div>
								<el-form class="jc-form cps-create-form" label-width="130px">
									<div class="tip-earlyWarning" style="margin-bottom:10px;">
										<i class="jc-icon-warning cff96"></i>
										{{$t('create.tooltip.netTypeWarning')}}
									</div>
									<el-form-item :label="$t('create.text.netType') | withColon">
										<el-radio-group v-model="selectedNetwork">
											<el-radio-button
												v-for="(item,key,index) in networks" :key="index"
												:label="key">{{item}}
											</el-radio-button>
										</el-radio-group>
										<el-tooltip
											style="margin-left:10px" effect="dark" placement="right"
											content="Right Top">
											<div slot="content" class="my-os-disk-tip">{{$t('create.tooltip.netType')}}
											</div>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
									</el-form-item>
									<el-form-item
										v-show="hasSubNet"
										:label="$t('create.text.privateNet') | withColon" >
										<div class="con">
											<div class="cl" v-show="isCreatedWithCidr">
												<div class="select-box time fl cidrSelectBox">
													<!--cidr下拉-->
													<el-select v-model="cidr1Val"
														style="width:70px;" :disabled="true" class="cidr-select">
														<el-option v-for="item in cidr1Option" :label="item" :value="item" :key="item"></el-option>
													</el-select>
												</div>
												<span class="stext">.</span>
												<div class="sdiv"><input type="text" class="inputMode w40 tcenter" v-model="cidr2Val" :disabled="true"></div>
												<span class="stext">.</span>
												<div class="sdiv"><input type="text" class="inputMode w40 tcenter" v-model="cidr3Val" :disabled="true"></div>
												<span class="stext">.</span>
												<div class="sdiv"><input type="text" class="inputMode w40 tcenter" v-model="cidr4Val" :disabled="true"></div>
												<span class="stext">/</span>
												<div class="select-box time fl cidrSelectBox">
													<!--cidr下拉框-->
													<el-select v-model="selectedMask" style="width:70px;" :disabled="true">
													<el-option v-for="item in cidr5Option" :label="item" :value="item" :key="item"></el-option>
													</el-select>
												</div>
												<el-tooltip class="ml10" effect="dark" placement="right" content="Right Top">-->
												  	<div slot="content" class="my-osdisk-tip">{{$t('create.tooltip.internalNetDisabled')}}</div>
												  	<a><i class="jc-icon-question"></i></a>
												</el-tooltip>
											</div>
										</div>
									</el-form-item>
								  	<el-form-item
								  		v-show="!hasSubNet"
								  		:label="$t('create.text.privateNet') | withColon">
										<div class="con">
										  	<div class="cl" id="CIDR" v-show="isCreatedWithCidr">
												<div class="select-box time fl cidrSelectBox">
												  	<!--cidr下拉-->
												  	<el-select id="cidr5-select" v-model="cidr1Val" @change="cidr5Val = cidr5Option[0];changeCidr1()" style="width:70px;">
														<el-option v-for="item in cidr1Option" :label="item" :value="item" :key="item"></el-option>
												  	</el-select>
												</div>
												<span class="stext">.</span>
												<div class="sdiv">
												  	<input  type="number" maxlength="3"  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" v-bind:class="{'cidr-not-in-range': cidr2ValueNotInRange}" @focus="tip2Focus = true;"
														  @blur="tip2Focus = false; blurCidr2Val(cidr2Val,selectCidrMapOption.availableData2);" class="inputMode w40 tcenter" v-model="cidr2Val" :disabled="selectCidrMapOption.secondDisable">
												  	<p class="right-tips" v-bind:class="{'not-in-range-tips':cidr2ValueNotInRange}" style="display: block;" v-show="tip2Focus && selectCidrMapOption.tip2">{{selectCidrMapOption.tip2}}</p>
												  	<div v-if="cidr2ValueNotInRange && tip2Focus" class="down-arrow"></div>
												</div>
												<span class="stext">.</span>
												<div class="sdiv">
												  	<input maxlength="3" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" v-bind:class="{'cidr-not-in-range': cidr3ValueNotInRange}" type="number" @focus="tip3Focus = true;"
														 @blur="tip3Focus = false;blurCidr3Val(cidr3Val,selectCidrMapOption.availableData3);" class="inputMode w40 tcenter" v-model="cidr3Val" :disabled="selectCidrMapOption.thirdDisable">
												  	<p class="right-tips" v-bind:class="{'not-in-range-tips':cidr3ValueNotInRange}" style="display: block;" v-show="tip3Focus && selectCidrMapOption.tip3">{{selectCidrMapOption.tip3}}</p>
												  	<div v-if="cidr3ValueNotInRange && tip3Focus" class="down-arrow"></div>
												</div>
												<span class="stext">.</span>
												<div class="sdiv">
												  	<input maxlength="3" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" v-bind:class="{'cidr-not-in-range': cidr4ValueNotInRange}" type="number" @focus="tip4Focus = true;"
														 @blur="tip4Focus = false;blurCidr4Val(cidr4Val,selectCidrMapOption.availableData4);" class="inputMode w40 tcenter" v-model="cidr4Val" :disabled="selectCidrMapOption.fourthDisable">
												  	<p class="right-tips" v-bind:class="{'not-in-range-tips':cidr4ValueNotInRange}" style="display: block;" v-show="tip4Focus && selectCidrMapOption.tip4">{{selectCidrMapOption.tip4}}</p>
												  	<div v-if="cidr4ValueNotInRange && tip4Focus" class="down-arrow"></div>
												</div>
												<span class="stext">/</span>
												<div class="select-box time fl cidrSelectBox">
													<!--cidr下拉框-->
													<el-select v-model="cidr5Val" @change="changeCidr5" style="width:70px;">
														<el-option v-for="item in cidr5Option" :label="item" :value="item" :key="item"></el-option>
													</el-select>
												</div>
												<el-tooltip class="ml10" effect="dark" placement="right" content="Right Top">-->
												  	<div slot="content" class="my-osdisk-tip">{{$t('create.tooltip.internalNet')}}</div>
												  	<a><i class="jc-icon-question"></i></a>
												</el-tooltip>
										  	</div>
										  	<div class="ml10">
												{{$t('create.help.will')}}<span class="cff96">{{cidr1Val + '.' + cidr2Val + '.' + cidr3Val + '.' +cidr4Val + '/' + cidr5Val}}</span>{{$t('create.help.distributeIp')}}<span
												class="cff96">{{cidr_map.cidrMap[cidr5Val]}}</span>{{$t('create.help.numCps')}}
										  	</div>
										</div>
								  	</el-form-item>
								  	<el-form-item
								  		:label="$t('create.text.firewall') | withColon"
								  		class="firewall">
										<el-select
											v-if="selectSwitch"
											v-model="selectedFirewall" :disabled='true' >
										 	<el-option
										 		v-for="item in firewalls" :key="item.id" :label="item.name"
												:value="item.id">
											</el-option>
										</el-select>
										<p class="el-form-item-help">{{$t('create.help.reference')}}<a
											:href="Config.FIRE_HELP_URL"
											target="_blank">{{$t('create.help.guide')}}</a>
										</p>
								  	</el-form-item>
								</el-form>
							</div>
						  	<!-- 带宽 -->
						  	<div class="jc-page-card">
								<div class="jc-page-card-header">
									<h3 class="jc-page-card-title">{{$t('create.text.bandwidth')}}</h3>
								</div>
								<el-form class="jc-form cps-create-form" label-width="130px"
									onsubmit="return false">
									<el-form-item :label="$t('create.text.publicIp') | withColon">
										<input
											id="controlCheckbox" type="checkbox"
											@click="changeDialogAndBindArea"
											v-model="radioIp"/>
										<span class="network-ip">{{$t('create.text.auto')}}</span>
										<el-tooltip
											style="margin-left:-10px" effect="dark" placement="right"
											content="Right Top">
										  	<div slot="content" class="my-os-disk-tip">{{$t('create.tooltip.auto')}}</div>
										  	<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
									</el-form-item>
								  	<el-form-item :label="$t('create.help.enableIpv6') | withColon"
										v-if="showIpv6Map[selectedRegion] === 'yes' && radioIp">
										<input type="checkbox" @click="changeDialogAndBindArea" v-model="ipV6"/>
										<span class="network-ip">{{$t('create.help.autoIpv6')}}</span>
										<el-tooltip
											style="margin-left:-10px" effect="dark" placement="right"
											content="Right Top">
										  	<div slot="content" class="my-os-disk-tip">
												{{$t('create.help.autoPublicIpv6')}}
										  	</div>
										  	<a>
												<i class="jc-icon-question"></i>
										  	</a>
										</el-tooltip>
								  	</el-form-item>
								  	<el-dialog
								  		:title="$t('create.text.info')" :visible.sync="dialogVisible"
										size="small"
										class="basicEipDialog"
										:before-close="doClose">
										<span class="alert-makesure-buy-font">{{$t('create.help.publicIpNoConfirm')}}</span>
										<el-alert type="error" :title="$t('create.text.caution') | withColon" :closable="false"
											style="padding-top: 10px; margin-top: 15px; height: 100px"><br/>{{$t('create.help.noPublicIp')}}
										</el-alert>
										<div style="margin-top: 25px">
										  	<input id="agreeControl" type="checkbox" @click="changeBtnAttribute"/>
										  	<span class="alert-agree-read-font">{{$t('create.text.readAgree')}}</span>
										</div>
										<span slot="footer" class="dialog-footer">
										  	<el-button @click="doClose">{{$t('create.text.cancel')}}</el-button>
										  	<el-button @click="doConfirm" type="primary" :disabled=sureBtn>{{$t('create.text.confirm')}}</el-button>
										</span>
								  	</el-dialog>
								  	<div id="agreeControlArea" v-if="bandWidthArea || radioIp">
										<el-form-item :label="$t('create.text.banCalModel') | withColon">
										  	<el-radio-group v-model="selectedPaymentType">
												<el-radio-button
											  	:label="$t('create.placeholder.fixedBandwidth')"></el-radio-button>
										  	</el-radio-group>
										  	<el-tooltip style="margin-left:10px" effect="dark" placement="right"
												content="Right Top">
												<div slot="content" class="my-os-disk-tip">
													{{$t('create.tooltip.cal')}}
													<a v-bind:href="Config.Band_Width_BillUrl"
														target="_blank">{{$t('create.tooltip.detail')}}&gt;&gt;</a>
												</div>
												<a><i class="jc-icon-question"></i></a>
										  	</el-tooltip>
										</el-form-item>
										<el-form-item :label="$t('create.text.line') | withColon">
											<el-radio-group v-model="selectedLineType">
												<el-radio-button
													v-for="(item,key,index) in lineTypes" :key="index"
													:label="key">{{item}}
												</el-radio-button>
											</el-radio-group>
										  	<el-tooltip
										  		style="margin-left:10px" effect="dark" placement="right"
												content="Right Top">
												<div slot="content" class="my-os-disk-tip">{{$t('create.tooltip.line',[lineTypes[selectedLineType]])}}
												</div>
												<a><i class="jc-icon-question"></i></a>
										  	</el-tooltip>
										</el-form-item>
										<el-form-item :label="$t('create.text.bandLimit') | withColon">
										  	<div class="el-form-item-inline">
												<el-slider
												v-model="tmpMaxBandwidth" show-input
												@change="calSelectedMaxBandwidth" :max="200" :marks="marks"
												:debounce="0" :min="1" class="jc-slider-custom">
												</el-slider>
										  	</div>
										  	<p class="mt20">
												{{$t('create.help.ddosVpc')}}
												<a v-bind:href="Config.DDOS_URL"
													target="_blank">
													{{ $t('create.help.ddosVpcGuid') }}
												</a>
										  	</p>
										</el-form-item>
								  	</div>
								</el-form>
						  	</div>
						  	<!-- 基本信息 -->
						  	<div id="baseInfo" class="jc-page-card">
								<div class="jc-page-card-header">
									<h3 class="jc-page-card-title">{{$t('create.text.baseInfo')}}</h3>
								</div>
								<el-form
									class="jc-form cps-create-form" label-width="130px" :model="ruleForm"
									ref="ruleForm" :rules="rules">
								  	<!--实例名称-->
								  	<el-form-item
								  		:label="$t('detail.text.name') | withColon"
								  		prop="hostName"
										:show-message="false" required
										ref="hostName">
										<el-input v-model="ruleForm.hostName" style="width:500px;" placeholder=""
											@blur="ruleFormTag.hostName=1"
											@focus="ruleFormTag.hostName=0"></el-input>
										<el-tooltip style="margin-left:10px" effect="dark" placement="right">
											<div slot="content" class="my-os-disk-tip">
												{{$t('create.help.instanceName')}}
											</div>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
										<p 	v-if="ruleFormTag.hostName!==0 && ruleForm.hostName==''"
										   	class="el-form-item-help-error">
										  	{{$t('create.placeholder.nameNull')}}</p>
										<p 	v-else class="el-form-item-help"
										   	:class="{'el-form-item-help-error': this.ruleFormTag.hostName == 'error'}">
											{{$t('create.help.instanceNameRule1')}}</p>
								  	</el-form-item>
									<!--描述-->
									<el-form-item
										:label="$t('create.text.desc') | withColon" prop="hostDesc"
										:show-message="false" ref="hostDesc">
										<el-input
											type="textarea" :rows="4" style="width:500px;"
											v-model="ruleForm.hostDesc"
											placeholder=""></el-input>
										<p class="el-form-item-help"
										   	:class="{'el-form-item-help-error': this.ruleFormTag.hostDesc == 'error'}">
											{{$t('create.help.desc')}}</p>
									</el-form-item>
								  	<!--主机名-->
									<el-form-item
										:label="$t('create.text.hostName') | withColon" prop="mainName"
										:show-message="false"
										ref="mainName">
										<el-input
											v-model="ruleForm.mainName" style="width:500px;"
											:placeholder="$t('create.placeholder.mainName')"
											@blur="ruleFormTag.mainName=1"
											@focus="ruleFormTag.mainName=0"></el-input>
										<el-tooltip style="margin-left:10px" effect="dark" placement="right">
											<div slot="content" class="my-os-disk-tip">{{$t('create.help.hostName')}}
											</div>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
										<p class="el-form-item-help"
										   	:class="{'el-form-item-help-error': this.ruleFormTag.mainName == 'error'}">
											{{$t('create.help.mainServerNameRule')}}</p>
									</el-form-item>
									<!--用户名-->
									<el-form-item :label="$t('create.text.username')|withColon">
										<span>{{hostUserName}}</span>
									</el-form-item>
									<!--登陆方式-->
									<el-form-item :label="$t('create.text.setPassword')|withColon">
										<input type="radio" v-model="passwordType" value="custom" id="custom"
										class="label-align" />
										<label for="custom">
											{{ $t('create.text.customizedPassword') }}
										</label>
										<input type="radio" v-model="passwordType" value="auto" id="auto"
										class="auto-password-position label-align"/>
										<label for="auto">
											{{ $t('create.text.autoPassword') }}
										</label>
										<input v-if="selectedOS !== 'Windows'" type="radio" v-model="passwordType" value="key" id="key"
										class="auto-password-position label-align"/>
										<label v-if="selectedOS !== 'Windows'" for="key">
											{{ $t('create.text.publicKey') }}
										</label>
										<el-tooltip style="margin-left:10px" effect="dark" placement="right">
											<div slot="content" class="my-os-disk-tip">
												{{$t('create.tooltip.loginTip')}}
										  	</div>
										  	<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
									</el-form-item>
								  	<!--密码-->
								  	<el-form-item
								  		:label="$t('create.text.password')|withColon" required prop="hostPwd"
										:show-message="false"
										ref="hostPwd"
										v-if="setPasswordShow">
										<el-input
											style="width:500px;" v-model="ruleForm.hostPwd" type="password"
											auto-complete="off"
											@blur="ruleFormTag.hostPwd=1"
											@focus="ruleFormTag.hostPwd=0"></el-input>
										<p 	v-if="ruleFormTag.hostPwd!==0 && ruleForm.hostPwd==''"
											class="el-form-item-help-error">
											{{$t('create.placeholder.passNull')}}</p>
										<p  v-else class="el-form-item-help"
										    :class="{'el-form-item-help-error': this.ruleFormTag.hostPwd == 'error'}">
											{{$t('create.help.password')}}</p>
								  	</el-form-item>
								  	<!--确认密码-->
								  	<el-form-item
								  		:label="$t('create.text.passwordConfirm')|withColon" required
										prop="hostConfirmPwd"
										:show-message="false" ref="hostConfirmPwd"
										v-if="setPasswordShow">
										<el-input style="width:500px;" v-model="ruleForm.hostConfirmPwd" type="password"
											auto-complete="off"
											@blur="ruleFormTag.hostConfirmPwd=1"
											@focus="ruleFormTag.hostConfirmPwd=0"></el-input>
										<p
											v-if="ruleFormTag.hostConfirmPwd!==0 && ruleForm.hostConfirmPwd==''"
											class="el-form-item-help-error">
											{{$t('create.placeholder.confirmPassNull')}}</p>
										<p
											v-if="ruleFormTag.hostConfirmPwd!==0 && ruleForm.hostConfirmPwd !== '' && ruleForm.hostPwd !== ruleForm.hostConfirmPwd"
											class="el-form-item-help-error">{{$t('create.placeholder.passNotSame')}}</p>
								  	</el-form-item>
								  	<!--密钥对-->
									<el-form-item :label="$t('create.text.linkSSHKey') | withColon" v-if="!setKeyPairsShow">
										<el-switch
											v-model="setKeyState"
											on-text=""
											off-text=""
											:disabled="selectedOS ==='Windows'">
										</el-switch>
										<el-tooltip style="margin-left:10px" effect="dark" placement="right">
											<div slot="content" class="my-os-disk-tip">
											{{$t('create.tooltip.keyPairTips')}}
											</div>
										  	<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
										<p v-if="!setKeyState">{{$t('create.text.keyTips')}}</p>
									</el-form-item>
									<!--密钥对单选-->
								  	<el-form-item
								  		:label="$t('create.text.key')|withColon"
										v-if="setKeyState && !setKeyPairsShow"
										prop="selectKey"
										:show-message="false">
										<el-select
											v-model="ruleForm.selectKey" class="select-vpc"
											@visible-change="getRealTimePublicKey"
											:placeholder="$t('listPage.placeholder.choose')"
											:no-data-text="$t('speechCraft.listNoText')">
										  	<el-option
										  		v-for="(key, index) in keyShowList"
												:key="index"
												:label="key.name"
												:value="key.keypairId">
										  	</el-option>
										</el-select>
										<el-button type="text" @click="jumpToKeys">
											{{ $t('ssh.text.create') }}
										</el-button>
										<p class="el-form-item-like">
										  	{{$t('create.help.publicKeySetting')}}
											<a
												:href="Config.SSH_HELP_URL"
												target="_blank">
												{{$t('privateNetInstance.operateGuid')}}
											</a>
										</p>
								  	</el-form-item>
								  	<!--密钥对多选-->
									<el-form-item :label="$t('create.text.key') | withColon"
										v-if="setKeyPairsShow"
										prop="selectKey"
										:show-message="false">
										<secret-key :region="selectedRegion"
											v-model="ruleForm.selectKey"
										></secret-key>
									</el-form-item>
									<!--SOS密钥对-->
									<el-form-item :label="$t('privateNetInstance.SOSKeyPair') | withColon"
										v-if="setKeyPairsShow"
										prop="sosKey"
										:show-message="false">
										<sos-secret-key :region="selectedRegion"
											v-model="ruleForm.sosKey"
										></sos-secret-key>
									</el-form-item>
								</el-form>
						  	</div>
						  	<!-- 高级设置 -->
						  	<div id="advanced" class="jc-page-card advanced-setting">
								<div class="jc-page-card-header">
									<h3 class="jc-page-card-title">{{$t('create.text.advanced')}}</h3>
								</div>
								<custom-data
									:setCustomData.sync="advancedSetting"
									ref="advancedCustomData"
									:region="selectedRegion"
									:selectedOS="selectedOS"
									@getCustomData="getCustomData">
								</custom-data>
								<el-form class="jc-form tags-form"
									:model="tagForm"
									label-width="130px"
									:rules="tagRules">
									<el-form-item class="code-value-tip" :label="$t('listPage.text.tags') | withColon">
										<jcb-tag-creationform
											v-model="tagForm.tags"
											ref="tagForm"
											:regionId="selectedRegion"
											@error="errorHandler">
										</jcb-tag-creationform>
									</el-form-item>
								</el-form>
						  	</div>
							<!-- 购买量 -->
							<div class="jc-page-card">
								<div class="jc-page-card-header">
									<h3 class="jc-page-card-title">{{$t('create.text.buyNo')}}</h3>
								</div>
								<el-form class="jc-form cps-create-form" label-width="130px">
								  	<el-form-item
								  		v-if="currentMode === 'tab1'"
								  		:label="$t('create.text.buyTimeSpan') | withColon">
										<div class="my-time-length">
											<div class="time-slide">
												<ul class="time-choose cl">
												  	<!--0折用户-->
												  	<el-tooltip
												  		effect="dark" placement="top"
														v-if="allDiscountedInfo[index - 1].message[0] !== ''"
														v-for='index in firstNine' >
														<div slot="content">
															{{ allDiscountedInfo[index - 1].message[0] }} <br/>
														</div>
														<li @click="selectMonth(index)"
															:class="getClass(index)">
															<i></i>{{index}}
														</li>
												  	</el-tooltip>
												  	<!--普通用户-->
												  	<li v-for='index in firstNine' @click="selectMonth(index)"
														:class="getClass(index)"
														v-if="allDiscountedInfo[index - 1].message[0] === ''">
														{{index}}
												  	</li>
												  	<!--0折用户-->
												  	<el-tooltip effect="dark" placement="top"
														v-if="allDiscountedInfo[index + 8].message[0] !== ''"
														v-for='index in lastThree' >
														<div slot="content">
														  {{ allDiscountedInfo[index + 8].message[0] }} <br/>
														</div>
														<li @click="selectYear(index)" class="time-discount"
															:class="getClass(12 * index)">
														  <i></i>{{index + $tc('create.text.yearUnit', index)}}
														</li>
												  	</el-tooltip>
												  	<!--普通用户-->
												  	<li v-for='index in lastThree' @click="selectYear(index)"
														:class="getClass(12 * index)"
														v-if="allDiscountedInfo[index + 8].message[0] === ''"
														class="time-discount">
													{{index + $tc('create.text.yearUnit', index)}}
												  	</li>
												</ul>
											</div>
										</div>
								  	</el-form-item>
								  	<!--自动续费-->
								  	<el-form-item
										v-if="currentMode === 'tab1'"
										:label="$t('create.text.autoRenew') | withColon" >
										<input id="autoRenewCheckbox" type="checkbox" v-model="autoRenew"/>
										<span >{{$t('create.text.autoRenewTip')}}</span>
										<el-tooltip style="margin-left:10px" effect="dark" placement="right">
											<div slot="content" class="my-app-tip">
												{{ $t('create.tooltip.autoRenew') }}
											</div>
											<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
								  	</el-form-item>
								  	<el-form-item :label="$t('create.text.count')  | withColon">
										<el-input-number
											v-model="selectedHostNumber" :min="1" :max="maxHostNumber"
											label="" @input.native="changeSelectedNumber">
										</el-input-number>
										<el-tooltip style="margin-left:10px" effect="dark" placement="right">
											<div slot="content" class="my-app-tip">{{$t('create.help.maxNum')}}<a
												v-bind:href="Config.WORK_URL" target="_blank" style="color:#2C68FF">{{$t('create.tooltip.ticket')}}</a>
											</div>
										  	<a><i class="jc-icon-question"></i></a>
										</el-tooltip>
								  	</el-form-item>
								</el-form>
							</div>
						</div>
				  	</div>
				  	<!-- 已选配置 -->
				  	<div id="selected" class="jc-form-create-selected">
						<h3 class="selected-title">
					  	{{$t('create.text.selectedConfig')}}</h3>
						<el-form label-width="100px" class="jc-datashow-list">
							<section class="selected-configure">
								<!--地域-->
								<el-form-item :label="$t('create.text.region')">
									<p v-if="regions[selectedRegion]">
									  {{regions[selectedRegion]}}
									</p>
									<p v-else>--</p>
								</el-form-item>
							  	<!--可用区-->
							  	<el-form-item :label="$t('create.text.az')" :title="$t('create.text.az')">
									<p v-if="zones[selectedRegion][selectedZone]">
									  {{zones[selectedRegion][selectedZone]}}
									</p>
									<p v-else>--</p>
							  	</el-form-item>
							  	<!--规格-->
							  	<el-form-item :label="$t('create.text.spec')">
									<p class="selected-ellipsis"
									   v-if="selectedStandardName"
									   :title="selectedStandardName">
									  {{selectedStandardName}}
									</p>
									<p v-else>--</p>
							  	</el-form-item>
							  	<!--镜像-->
								<el-form-item :label="$t('create.text.mirror')">
									<p v-if="selectedOSName">
									  {{selectedOSName}}
									</p>
									<p v-else>--</p>
								</el-form-item>
							  	<!--系统盘-->
							  	<el-form-item :label="$t('create.text.sysDisk')" :title="$t('create.text.sysDisk')">
									<p v-if="selectedSysRaidName">
									  {{selectedSysRaidName}}
									</p>
									<p v-else>--</p>
							  	</el-form-item>
							  	<!--数据盘-->
								<el-form-item :label="$t('create.text.dataDisk')" :title="$t('create.text.dataDisk')">
									<p class="selected-ellipsis" v-if="selectedDataRaidName"
									   :title="selectedDataRaidName">
									  {{selectedDataRaidName}}
									</p>
									<p v-else>--</p>
								</el-form-item>
							  	<!--内部网络-->
							  	<el-form-item :label="$t('create.text.privateNet')" :title="$t('create.text.privateNet')">
									<p class="selected-ellipsis" v-if="selectedCidr"
									   :title="cidr1Val + '.' + cidr2Val + '.' + cidr3Val + '.' +cidr4Val + '/' + cidr5Val">
									  {{$t('create.help.autoAllocate',[cidr1Val + '.' + cidr2Val + '.' + cidr3Val + '.'
									  +cidr4Val + '/' +
									  cidr5Val])}}</p>
									<p v-else>--</p>
							  	</el-form-item>
							  	<!--公网IP-->
								<el-form-item :label="$t('create.text.publicIp')">
									<p v-if="lineTypes[selectedLineType] && radioIp">
									  {{$t('create.help.byBandwidth', [lineTypes[selectedLineType], selectedMaxBandwidth])}}
									</p>
									<p v-else>--</p>
								</el-form-item>
							  	<!--购买时长-->
							  	<el-form-item
							  		v-if="currentMode === 'tab1'"
							  		:label="$t('create.text.buySpan')"
									:title="$t('create.text.buyTimeSpan')">
									<p  v-if="selectedMonth % 12 != 0">
										{{selectedMonth}} {{$tc('create.text.month', selectedMonth)}}
									</p>
									<p  v-else-if="selectedMonth % 12 == 0">
										{{selectedMonth / 12}} {{$tc('create.text.yearUnit', selectedMonth / 12)}}</p>
									<p v-else>--</p>
							  	</el-form-item>
							  	<!--购买数量-->
							  	<el-form-item :label="$t('create.text.buyNum')">
									<p>{{selectedHostNumber}}</p>
							  	</el-form-item>
							</section>
						  	<!--费用-->
						  	<section class="selected-cost">
						  		<h3 class="selected-cost-title">
								{{$t('create.text.cost')}}</h3>
							  	<!--包年包月计费-->
							  	<div v-if="currentMode === 'tab1'">
								  	<el-form-item
								  		:label="$t('create.text.server')">
										<p class="form-item-nopadding" :class="[totalDiscount > 0?'':'form-item-bottom' ]">
										  <span class="price">￥{{discountedServerPrice}}</span>
										  <span class="none">{{calTotalPrice.discountedServerPrice}}</span>
										</p>
								  	</el-form-item>
								  	<el-form-item
								  		v-if="radioIp"
								  		:label="$t('detail.text.publicNetIP')">
									  	<p class="form-item-nopadding" :class="[totalDiscount > 0?'':'form-item-bottom' ]">
											<span class="price">￥{{discountedEipPrice}}</span>
											<span class="none">{{calTotalPrice.discountedEipPrice}}</span>
										</p>
									</el-form-item>
									<save-price
										v-if="totalDiscount > 0"
										:totalDiscount="favorablePricePerHour"
										:originPrice="totalPrice"
									></save-price>
								</div>
								<!--按配置计费-->
								<div v-if="currentMode === 'tab2'">
								  	<el-form-item
								  		:label="$t('create.text.server')">
										<p class="form-item-nopadding" :class="[configurationsTotalDiscount > 0?'':'form-item-bottom' ]">
										  	<span class="price cff96">
										  	{{ $t('create.text.feePerHour', [discountByConfigurationsServerPrice])}}</span>
										  	<span class="none">{{configurationCalTotalPrice.discountByConfigurationsServerPrice}}</span>
										</p>
								  	</el-form-item>
								  	<el-form-item
								  		v-if="radioIp"
								  		:label="$t('detail.text.publicNetIP')">
									  	<p class="form-item-nopadding" :class="[configurationsTotalDiscount > 0?'':'form-item-bottom' ]">
											<span class="price">{{ $t('create.text.feePerHour', [discountByConfigurationsEipPrice])}}</span>
											<span class="none">{{configurationCalTotalPrice.discountedEipPrice}}</span>
										</p>
									</el-form-item>
									<p class="month-total-price">
										<span>{{ $t('create.text.configureMonthPay', [discountByConfigurationsOneMonthPrice]) }}</span>
										<span class="none">{{configurationCalTotalPrice.discountByConfigurationsOneMonthPrice}}</span>
										<span class="none">
											{{calTotalPrice.discountedTotalPrice}}
										</span>
									</p>
									<save-price
										v-if="configurationsTotalDiscount > 0"
										:totalDiscount="configurationsTotalDiscount"
										:originPrice="configurationsTotalPrice"
									></save-price>
								</div>
							  	<el-button
							  		type="primary" size="large"
									:disabled="!isStockEnough || moreThanAvailableQuota || !selectedStandard || !isCertification"
									class="my-buy-btn" @click="buy()">{{isBuyTag}}
							  	</el-button>
						  		<p  v-if="currentMode === 'tab2'"
									class="like-form-help-item">
									{{ $t('create.text.yearPackage', [discountedTotalPrice]) }}
								</p>
							 	<p  v-if="!isCertification" style="color:red;margin-top:10px;">
									{{$t('create.help.noCertification')}}
									<a :href="Config.REALNAME_URL">
									  {{$t('create.help.goCertificate')}}</a>
							  	</p>
							  	<p v-else-if="!isStockEnough" style="color:red;margin-top:10px;">
									<span
										v-if="cacheDeviceTypesNum[selectedStandard]">{{$t('create.help.restock')}}</span>
									<span v-else>{{$t('create.help.soldOut')}}</span>{{$t('create.help.contact')}}
									<a v-bind:href="Config.WORK_URL" target="_blank">{{$t('create.tooltip.ticket')}}</a>
							  	</p>
							  	<p v-else-if="isStockEnough && moreThanAvailableQuota" style="color:red">
									{{$t('create.help.exceedQuota')}}{{$t('create.help.contact')}}
									<a v-bind:href="Config.WORK_URL" target="_blank">{{$t('create.tooltip.ticket')}}</a>
							  	</p>
							  	<p v-else-if="isStockEnough && selectedStandard == ''"
									style="color:red;margin-top:10px;">
									<span
										v-if="cacheDeviceTypesNum[selectedStandard]">{{$t('create.help.restock')}}</span>
									<span v-else>{{$t('create.help.soldOut')}}</span>{{$t('create.help.contact')}}
									<a v-bind:href="Config.WORK_URL" target="_blank">{{$t('create.tooltip.ticket')}}</a>
							  	</p>
							</section>
						</el-form>
				  	</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
	import ifCertification from '@/mixins/ifCertification';
	import {cidrList} from '@/common/ConstParam.js';
	import {ChargeModeConstant, NetworkTypeConstant, CreateTypeConstant, ServiceCodeConstant, PasswordRuleConstant, BillingTypesConstant, CustomPartitionSupportConstant} from '@/common/Constants'
	import VueCookie from 'vue-cookie'
	import cidr from '@/components/common/cidr/Cidr';
	import SavePrice from '@/components/common/SavePrice';
	import CustomPartition from '@/components/common/customPartition/customPartition';
	import CustomData from '@/components/common/customData/CustomData';
	import SecretKey from '@/components/common/secretKey/SecretKey';
	import SosSecretKey from '@/components/common/sosSecretKey/SosSecretKey';
	import {changeTwoDecimal,isEmptyObject, mulDecimals, subDecimals, divDecimals} from '@/common/tool';
	import { deepCopy } from '@/common/tool';
	import initSelectedPotision from '@/mixins/initSelectedPotision';
	import buyTime from '@/mixins/buyTime';
	export default {
		components: {
			cidr,
			CustomPartition,
			CustomData,
			SavePrice,
			SecretKey,
			SosSecretKey
		},
		mixins:[ifCertification, initSelectedPotision,buyTime],
		data() {

			var validatePassword = (rule, value, callback) => {
				var rule = PasswordRuleConstant;
				var result = rule.test(value)
				if (!result) {
				  callback(new Error(this.$t('create.placeholder.passNotMeetRequire')));
				  return
				}
				callback();
			}

			var validateConfirmPassword = (rule, value, callback) => {
				if (value == '') {
				  callback(new Error(this.$t('create.placeholder.passNotMeetRequire')))
				} else if (value != this.ruleForm.hostPwd) {
				  callback(new Error(this.$t('create.placeholder.passwordNotSame')))
				} else {
				  callback();
				}
			}

			// 验证主机名
			var validateHostName = (rule, value, callback) => {
				var reg = /(^((?!(^-)|(-$)|(--+)|(^\\.)|(\\.$)|(\\.\\.+))[0-9A-Za-z-.{}]){2,64}$)|(^\s*$)/;
				if (value != '') {
				  var result = reg.test(value)
				  if (!result) {
					callback(new Error(this.$t('create.placeholder.hostNameNotRequire')));
					return
				  }
				}
				callback();
			}

			const standardImage = this.$t('create.text.standardImage');
			const standardAppImage = this.$t('create.text.standardAppImage');

			return {
				currentMode: 'tab1',
				isVip: false, // 是否为大客户(true: 是)
				passwordType: 'custom',
				selectSwitch: true,
				bandWidthArea: true,
				sureBtn: true,
				dialogVisible: false,
				quotaState: -100,
				helpVisible: false,
				quotaNumber: 0,
				creatVisibile: false,
				cidr_map: {
				  	cidrMap: {
						16: 65534,
						17: 32766,
						18: 16382,
						19: 8190,
						20: 4094,
						21: 2046,
						22: 1022,
						23: 510,
						24: 254,
						25: 126,
						26: 62,
						27: 30,
						28: 14,
				  	}
				},
				clientToken: Normal.getClientToken(),
				ruleFormType: {
					type: this.selectedOSTypeId,
					application: this.selectedApplication
				},
				//区域
				selectedRegion: '',
				selectedZone: '',
				//规格
				selectedStandard: "",
				selectedStandardName: "",
				deviceCustomPartitionSupport: true,
				//查询规格
				searchType: '',
				//镜像
				selectedImageType: 0,
				selectedOS: "",
				selectedOSTypeId: "",
				isCentOS66: false,
				selectedApplication: [],
				//存储
				selectedSysRaidName: '',
				selectedSysRaidTip: '',
				selectedDataRaid: {},
				selectedDataRaidName: "",
				selectedOSRaidId: "",
				selectedDataRaidId: "",
				sysDiskCapacity: '',
				dataDiskCapacity: '',
				systemDiskPartitionModes: [
					{id:1,label:this.$t('create.text.defaultPartitionModes'),value:'default'},
					{id:2,label:this.$t('create.text.customPartitionModes'),value:'custom'},
				],
				selectedPartitionMode: 'default',
				defaultSystemDataPartitions: '',
				systemDataCustomPartitionVisible: false,
				systemDataPartitions: [],
				systemDiskSize: 0,
				dataDiskPartitionModes: [
					{id:1,label:this.$t('create.text.defaultPartitionModes'),value:'default'},
					{id:2,label:this.$t('create.text.customPartitionModes'),value:'custom'},
				],
				selectedDataDiskPartitionMode: 'default',
				defaultDataDiskPartitions: '',
				dataDiskPartitions: [],
				dataDiskSize: 0,
				stockEnough: false,
				//网络
				selectedNetwork: "basic",
				selectedNetworkFirst: "*",
				selectedMask: "*",
				selectedCidr: '*.*.*.*/*',
				selectedFirewall: 1,

				//带宽
				selectedPaymentType: this.$t('create.placeholder.fixedBandwidth'),
				selectedLineType: "bgp",
				tmpMaxBandwidth: 1,
				selectedMaxBandwidth: 1,
				//基本信息
				hostName: "",
				hostDesc: "",
				hostUserName: "root",
				hostPwd: "",
				hostConfirmPwd: "",
				// 高级设置
				tagForm: {
					tags: []
				},
				tagRules: {

				},
				//购买数量
				selectedMonth: 1,
				cutMonth: 0,
				selectedHostNumber: 1,
				maxHostNumber: 5,
				//实名认证
				isBuyTag: this.$t('create.text.buyNow'),
				//库存
				isStockEnough: true,
				//包年包月价格
				isCalculatIng: false, // 包年包月计费中
				discountedTotalPrice: '--',
				discountedServerPrice: '--',
				discountedEipPrice: '--',
				totalPrice: 0,
				totalDiscount: 0,

				// 按配置价格
				isConfigurationsCalculatIng: false, // 按配置计费中
				discountByConfigurationsServerPrice: '--',
				discountByConfigurationsEipPrice: '--',
				discountByConfigurationsOneMonthPrice: '--',
				configurationsTotalPrice: '--',
				configurationsTotalDiscount: '--',

				//页面参数选择
				regions: {},
				zones: {"": {}},
				deviceTypes: {},
				// 不同规格类型的库存数量
				deviceTypesNum: {},
				cacheDeviceTypesNum: {},
				// 用于页面倒叙展示规格
				deviceTypesArr: [],
				imageTypes: [],
				osTypes: {},
				standardOsTypes: {},
				customOsTypes: {},
				applications: [],
				applicationsExtend: {
				  "Nginx": {
					class: "my-nginx",
				  },
				  "MySQL": {
					class: "my-mysql",
				  },
				  "RabbitMQ": {
					class: "my-rabbitmq",
				  },
				},
				otherMonth: 0,
				raids: [],
				networks: {"basic": this.$t('create.text.basic')},
				cidrArr: ['*', '*', '*', '*'],
				firewalls: [
				  {id: 1, name: this.$t('create.help.firewall')},
				  {id: 2, name: this.$t('create.help.publicOpen')}
				],
				lineTypes: {},
				//数据盘提示列表
				radisNameMap: {
				  NORAID: 'NO RAID',
				  RAID0: 'RAID0',
				  RAID1: 'RAID1',
				  RAID10: 'RAID10',
				  RAID5: 'RAID5',
				  RAID51H: 'RAID 5+1 hotspare+NO RAID'
				},
				customRaidsNameMap:{
					RAID51H: 'RAID 5+1 hotspare',
					NORAID: 'NO RAID'
				},
				// 表单验证
				ruleForm: {
					hostName: "",
					hostDesc: "",
					hostPwd: "",
					hostConfirmPwd: "",
					mainName: '',
					publicKey: [], // 密钥对
					selectKey: '', // 选中的密钥对
					sosKey: '', // sos密钥对
				},
				ruleFormTag: {
					hostName: 0,
					hostDesc: 0,
					hostPwd: 0,
					hostConfirmPwd: 0,
					mainName: 0,
					application: 0,
				},
				rulesType: {},
				rules: {
					hostName: [
						{
						  type: 'string',
						  pattern: new RegExp('^[a-zA-Z\\\u4e00-\\\u9fa5]([0-9a-zA-Z\\\u4e00-\\\u9fa5-_.:{}]{1,127})$'),
						  trigger: 'blur'
						}
					],
					hostDesc: [
						{type: 'string', pattern: new RegExp('^.{0,256}$'), trigger: 'blur'}
					],
					hostPwd: [
						{validator: validatePassword, trigger: 'blur'}
					],
					hostConfirmPwd: [
						{validator: validateConfirmPassword, trigger: 'blur'}
					],
					mainName: [
						{validator: validateHostName, trigger: 'blur'}
					],
					selectKey: [
						{ required: true, trigger: 'change' }
					],
					sosKey: [
						{ required: true, trigger: 'change' }
					]
				},
				tip2Focus: false,
				tip3Focus: false,
				tip4Focus: false,
				isCreatedWithCidr: true,
				cidr1Val: 10,
				cidr2Val: 0,
				cidr3Val: 0,
				cidr4Val: 0,
				cidr5Val: 16,
				cidr1Option: [10, 172, 192],
				cidr5Option: [16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28],
				selectCidrMapOption: cidrList.cidrOption['10']['16'],
				hasSubNet: false,
				userType: '',
				ipChecked: true,
				radioIp: true,
				regionChanged: false,
				cidr2ValueNotInRange: false,
				cidr3ValueNotInRange: false,
				cidr4ValueNotInRange: false,
				//ssh密钥
				setKeyState: true,
				timeUnit: 3,
				chargeUnit: 3,//月 计费时长单位 1:小时 2:天 3:月 4:年,
				selectedYear: 1,//选择年份,
				allSold: true,
				scrolled: false,
				showIpv6Map: [],//是否显示ipv6 checkbox
				ipV6: false,//是否启用IPV6,
				deviceTypesTable: [],//系列对应的机型列表数据
				deviceTypesTableData: [],
				deviceTypesTableData1: [],
				deviceTypesTableData2: [],
				selectedSeries: 'compute',//所选系列，默认选择计算型,
				seriesMap: {
					//系列对应的中文名称
					compute: this.$t('create.text.computeType'),
					storage: this.$t('create.text.storageType'),
					gpu: this.$t('create.text.gpuType')
				},
				// 0折用户折扣信息
				allDiscountedInfo: [
					{message: []},
					{message: []},
					{message: []},
					{message: []},
					{message: []},
					{message: []},
					{message: []},
					{message: []},
					{message: []},
					{message: []},
					{message: []},
					{message: []},
				],
				// 折扣信息
				discountedInfo: {},
				// 前9个月
				firstNine: [1, 2, 3, 4, 5, 6, 7, 8, 9],
				// 后三年
				lastThree: [1, 2, 3],
				//自动续费
				autoRenew: false,
				//默认选中第四个raid的机型（这两个机型的第四个raid都是raid10）
				defaultForthRaidDeviceTypes: [
					'cps.c.perf2',//计算效能型II
					'cps.s2.normal'//标准存储型（二代）
				],
				//默认选中第三个raid的机型
				defaultThirdRaidDeviceTypes: [
					'cps.c.normal',//标准计算型（默认raid1）
					'cps.gpu.1',//GPU I（默认raid10）
					'cps.gpu.2',//GPU II（默认raid10）
					'cps.gpu.3',//GPU III（默认raid10）
				],
				// 高级设置开关
				advancedSetting: false,
				userData: '', // 高级设置脚本内容，已base64过
				marks: {1:'1Mbps',200:'200Mbps'},
                favorablePricePerHour: '--', // // 省 = 原价 - 应付
                showOsTypes: false,
			}
		},
		computed: {
			systemType() {
				return this.selectedOS === 'Windows' ? 'windows' : 'linux';
			},
			/**
			* 密钥对下拉列表
			* @return array
			*/
			keyShowList() {
				if (this.ruleForm.publicKey.length) {
				  return this.ruleForm.publicKey.map(key => ({
					keypairId: key.keypairId,
					name: key.name,
					publicKey: key.publicKey
				  }));
				}
			},
			/**
			* 根据选择可用区判断是否显示设置密码
			* @return Boolean
			*/
			setPasswordShow() {
				return this.passwordType === 'custom';
			},
			/**
			* 根据选择的可用区及登陆方式判断是否显示密钥对
			*/
			setKeyPairsShow() {
				return this.passwordType === 'key';
			},
			/**
			* 根据选择可用区判断是否显示设置密码
			* @return Boolean
			*/
			setPasswordShow() {
				return this.passwordType === 'custom';
			},
			selectedOSName: function () {
				if (this.selectedOS && this.selectedOSTypeId) {
				  for (var i in this.osTypes[this.selectedOS]) {
					if (this.osTypes[this.selectedOS][i]['osTypeId'] == this.selectedOSTypeId) {
					  return this.osTypes[this.selectedOS][i]['osName']
					}
				  }
				}
				return ''
			},
			/**
		 	* 包年包月计算
		 	*/
			calTotalPrice: function () {
				return this.calculateTotalPrice()
			},
			/**
			 * 按配置计算
			*/
			configurationCalTotalPrice() {
				return this.configurationsCalculateTotalPrice();
			},
			moreThanAvailableQuota(){
				return this.quotaNumber < this.selectedHostNumber
			},
			currentDeviceType(){
				return this.selectedStandard;
			},
			currentDeviceTypeDetail(){
				if (this.deviceTypes[this.selectedStandard]) {
					return "(" + this.deviceTypes[this.selectedStandard]['name'] + " ,"
					+ this.deviceTypes[this.selectedStandard]['cpuConcise'] + " " +
					this.deviceTypes[this.selectedStandard]['memConcise'] + ")"
				}
			},
			ServiceCodeConstant: () => ServiceCodeConstant
		},
		watch: {
		  /**
		   * 设置密码类型改变时，初始化密码和确认密码内容及校验
		   * 暂定为watch，找不到@change可用
		   * @param newVal
		   */
			passwordType(newVal) {
				this.$refs.ruleForm.clearValidate(['hostPwd', 'hostConfirmPwd', 'selectKey']);
				this.ruleForm.hostPwd = '';
				this.ruleForm.hostConfirmPwd = '';
				this.ruleFormTag.hostPwd = 0;
				this.ruleFormTag.hostConfirmPwd = 0;
				this.ruleForm.selectKey = '';
				if (newVal === 'key') {
					this.getPublicKey();
				}
			},
			setKeyState() {
				this.$refs.ruleForm.clearValidate(['selectKey']);
				this.ruleForm.selectKey = '';
			},
			dialogVisible: function (val) {
				if (val === false) {
					document.getElementById("agreeControl").checked = false;
					this.sureBtn = true;
				}
			},
			cidr1Val: function (val){
				//console.log(val)
			},
			radioIp: function (val) {
				if (val === true) {
					this.selectedFirewall = 1;
				} else {
					this.selectedFirewall = 2;
				}
			},
			quotaState: function (newValue, oldValue) {
				if (newValue === 1) {
					this.helpVisible = false
					this.creatVisibile = true
				} else {
					this.helpVisible = true
					this.creatVisibile = false
				}
			},
			selectedRegion: function (newValue, oldVlue) {
				if (newValue) {
					//根据当前区域是否支持ipv6决定是否显示ipv6 checkbox
					this.showIpv6 = this.regions[newValue].enableIPV6;
					if (this.zones[this.selectedRegion]) {
						for (var az in this.zones[this.selectedRegion]) {
							this.selectedZone = az
							break
						}
					} else {
						this.selectedZone = ''
					}
					this.getLineTypes();
					this.getDeviceType();
					this.getSubnet();
					this.getQuota();
					this.regionChanged = true;
					this.selectedStandard = ''
					this.cidr2Val = 0;
					this.cidr3Val = 0;
					this.cidr4Val = 0;
					//切换区域，去掉启用IPv6勾选
					this.ipV6 = false;
				}
			},
			deviceTypesNum: function (newValue, oldVlue) {
				var flag = false
				if (newValue === 1) {
					for (let key in newValue) {
						if (newValue[key]) {
						  this.flag = true
						}
					}
				  this.stockEnough = flag
				}
			},
			selectedZone: function (newValue, oldVlue) {
				if (newValue) {
					this.getSubnet();
					this.getQuota();
					this.getDeviceType();
					this.selectedStandard = ''
					this.cidr2Val = 0;
					this.cidr3Val = 0;
					this.cidr4Val = 0;
				}
			},
			selectedSeries: function (newValue, oldVlue) {
				if (newValue) {
                    // 历史逻辑：先清空selectedStandard再回填，会重复触发selectedStandard赋值
                    // this.selectedStandard = '';
                    this.selectedOS = '';
                    this.osTypes[this.selectedOS] = [];
					this.searchType = '';
					this.handleIconClick();
				}
                this.initSelectedStandardBySeries(this.selectedSeries);
			},
			selectedStandard: function (newValue, oldVlue) {
				if (newValue == '') {
					this.selectedStandardName = '';
				} else {
					if (this.deviceTypes[newValue] != undefined) {
						this.selectedStandardName = this.selectedStandard
						  + "(" + this.deviceTypes[newValue]['cpuDetail'] + " "
						  + this.deviceTypes[newValue]['memDetail'] + "," +
						  this.deviceTypes[newValue]['name'] + ")"
						this.getAvailableOS(this.selectedImageType);
						this.getAvailableRaids(newValue);
						this.checkStockEnough(this.selectedRegion, this.selectedZone, newValue, this.selectedHostNumber);
						let customPartitionSupport = this.deviceTypes[newValue].customPartitionSupport;
						this.deviceCustomPartitionSupport = CustomPartitionSupportConstant[customPartitionSupport];
						this.resetPartitionModes(this.deviceCustomPartitionSupport);
					}
                    this.showOsTypes = true;
				}
				this.selectedOSTypeId = '';

			},
			selectedOS: function (newValue, oldValue) {
				this.$refs.osVersion.resetField();
				this.selectedOSTypeId = ''

                // 重置为默认分区后，清空自定义分区数据
                this.systemDataPartitions = []; // 系统盘
                this.dataDiskPartitions = []; // 数据盘
                this.selectedPartitionMode = 'default';
                this.selectedDataDiskPartitionMode = 'default';

				if(newValue === "Windows") {
					this.setKeyState = false;
				}
			},
			selectedOSTypeId: function (newValue, oldVlue) {
				this.ruleFormType.type = newValue;
				this.selectedApplication = [];
				if (!newValue) {
					return
				}
				let customPartitionSupport = this.deviceCustomPartitionSupport;
				let isQcow2 = this.osTypes[this.selectedOS].filter(item => item.osTypeId === newValue).every(item => item.osFormat === 'qcow2')
				this.resetPartitionModes(customPartitionSupport && !isQcow2);
				this.resetDataPartitionModes(this.selectedDataRaid);
				this.getOSPartitions();
			},
			selectedOSName (newValue, oldValue) {
				let spaceReg = /\s+/g;
				let osName = newValue.split(spaceReg).splice(0,2).join(' ');
				// CentOS 6.6自定义分区文件系统特殊处理标识
				if (osName === 'CentOS 6.6') {
					this.isCentOS66 = true;
				} else {
					this.isCentOS66 = false;
				}
			},
			selectedImageType: function (newValue, oldVlue) {
				if (newValue !== 'standard_app') {
				  this.osTypes = $.extend(true, {}, this.standardOsTypes);
				} else {
				  this.selectedOS = 'CentOS'
				  this.osTypes = $.extend(true, {}, this.customOsTypes);
				}
				this.getAvailableOS(this.selectedImageType)
				this.$refs.osVersion.resetField();
				this.selectedOSTypeId = ''
				this.selectedApplication = []
			},
			selectedApplication: function (newValue, oldVlue) {
				this.ruleFormType.application = newValue
				if (newValue.length) {
				  this.ruleFormTag.application = 0
				}
			},
			selectedPartitionMode(newValue, oldVlue) {
				if (newValue === 'default') {
                    // 重置为默认分区后，清空 系统盘 自定义分区数据
                    this.systemDataPartitions = [];
					this.resetDiskCapacity('system');
				}
			},
			selectedDataDiskPartitionMode(newValue, oldVlue) {
				if (newValue === 'default') {
                    // 重置为默认分区后，清空 数据盘 自定义分区数据
                    this.dataDiskPartitions = []; // 数据盘
					this.resetDiskCapacity('data');
				}
			},
			// 切换后面数量的时候，要查一下库存，是否满足当前数量
			selectedHostNumber: function (newValue, oldVlue) {
				for (let i = 0; i < this.deviceTypesArr.length; i++) {
				  this.checkStockEnough(this.selectedRegion, this.selectedZone, this.deviceTypesArr[i]['deviceType'], newValue)
				}
			// this.checkStockEnough(this.selectedRegion, this.selectedZone, this.selectedStandard, newValue)
			},
		},
		created() {
			this.getRegion()
			this.getUserIsCertification();
		},
		mounted() {
			this.getQuota();
		},
		methods: {
			/**
			* 获得用户类型
			*/
			getUserType() {
				const params = {
					region: this.selectedRegion
				};
				Ajax.get('/api/usercenter/describeBaseInfo', params)
				.then((res) => {
					res.data = JSON.parse(res.data.meta);
					if (typeof res.data.edcps_vip !== 'undefined') {
						this.isVip = res.data.edcps_vip.toString() === '1';
						this.setTab('tab',1,1)
					}
				});
			},
			// 只能输入整数
			changeSelectedNumber(val){
				clearTimeout(this.inputNumberTimeout);
				this.inputNumberTimeout = setTimeout(() => {
				  	let v = val.target.value;
                	v = v.replace(/[^0-9]/ig, '');
				  	this.selectedHostNumber = v
				}, 200)
			},
			/**
			* 主要是切换可用区为cn-north-1b时
			* 初始化loginType及相关绑定值
			* 其余zoneChange事件见watch
			*/
			zoneChange(zone) {
				this.ruleForm.selectKey = '';
				this.selectedStandard = '';
				this.clearPrice();
			},
			changeSeries() {
				this.clearPrice();
			},
			clearPrice() {
				this.configurationsTotalPrice = '--';
				this.discountByConfigurationsOneMonthPrice = '--';
				this.discountByConfigurationsServerPrice = '--';
				this.discountByConfigurationsEipPrice = '--';
				this.discountedTotalPrice = '--';
				this.discountedServerPrice = '--';
				this.discountedEipPrice = '--';
				this.favorablePricePerHour = '--';
				this.totalPrice = '--';
				this.configurationsTotalDiscount = '--';
				this.totalDiscount = '--';
			},
			/**
			* 跳转密钥列表
			*/
			jumpToKeys() {
				this.$router.push({
				  path: '/ssh/list',
				  query: {
					region: this.selectedRegion
				  }
				});
			},
			/**
			* 密钥对select为下拉状态时调用
			* 获得最新密钥对信息
			* @param tag
			*/
			getRealTimePublicKey(tag) {
				if (tag) {
				  this.getPublicKey();
				}
			},
			/**
			* 获得密钥对
			* 当登陆方式为'密钥登陆'时调用
			* 没有分页，所以pageSize为200
			*/
			getPublicKey() {
				const params = {
					region: this.selectedRegion,
					pageSize: 200
				};
				Ajax.get('/api/cps/listKeypairs', params)
				.then((res) => {
					this.ruleForm.publicKey = res.data.keypairs;
				})
				.catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				});
			},
			/**
			* 获取链路类型
			*/
			getLineTypes() {
				const param = {
			        region: this.selectedRegion
			    };
			    Ajax.get('/api/cps/getLineTypes', param)
			    .then((res) => {
		          	const data = res.data.lineTypes;
		          	for (let i = 0; i < data.length; i++) {
		          		this.lineTypes[data[i].lineType] = data[i].lineTypeName;
		          		this.selectedLineType = Object.keys(this.lineTypes)[0];
		          	}
			    }).catch(async (err)=>{
			    	const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
			    });
	  		},
			/**
			* 获得通过校验的输入内容
			* 且内容已经base64过了
			*/
			getCustomData(value) {
				this.userData = value;
			},
			/**
			* 改变区域时调用
			* 主要是初始化带宽上限和购买量为1
			* 以及初始化部分内容
			*/
			regionChange() {
				this.tmpMaxBandwidth = 1;
				this.selectedHostNumber = 1;
				this.ruleForm.selectKey = '';
				this.clearPrice();
				setTimeout(() => {
				  this.$refs.ruleForm.clearValidate(['selectKey']);
				}, 2000);
			},
			cidrChange(cidrValsInArray) {
				[this.cidr1Val, this.cidr2Val, this.cidr3Val, this.cidr4Val, this.cidr5Val] = cidrValsInArray;
			},
			changeBtnAttribute() {
				let check = document.getElementById("agreeControl");
				if (check.checked === true) {
				  this.sureBtn = false;
				} else {
				  this.sureBtn = true;
				}
			},
			changeDialogAndBindArea() {
				let checkbox = document.getElementById("controlCheckbox");
				if (checkbox.checked === false) {
				  this.dialogVisible = true;
				  this.bandWidthArea = true;
				  this.selectedFirewall = 2;
				} else {
				  this.bandWidthArea = false;
				  this.selectedFirewall = 1;
				}
			},
			handleIconClick() {
				var keyWord = this.searchType.replace(/\s+|\t+/g,'');
				let target =[];
				if(this.selectedSeries === 'compute'){
					var typeInfo = this.deviceTypesTableData
				}else if(this.selectedSeries === 'storage'){
					var typeInfo = this.deviceTypesTableData1
				}else if(this.selectedSeries === 'gpu'){
					var typeInfo = this.deviceTypesTableData2
				};

				for(let i in typeInfo) {
					let allDeviceType = typeInfo[i].deviceType;
					if(allDeviceType.match(keyWord)){
						target.splice(target.length, 0, typeInfo[i]);
					}
				}
				if(keyWord!=''){
					this.deviceTypesTable[this.selectedSeries] = target;
				}else if(this.selectedSeries === 'compute'&&keyWord===''){
					this.deviceTypesTable[this.selectedSeries] = this.deviceTypesTableData;
				}else if(this.selectedSeries === 'storage'&& keyWord===''){
					this.deviceTypesTable[this.selectedSeries] = this.deviceTypesTableData1;
				}else if(this.selectedSeries === 'gpu'&&keyWord===''){
					this.deviceTypesTable[this.selectedSeries] = this.deviceTypesTableData2;
				}
			},
			getClass(num) {
				if (VueCookie.get("jdcloud_sitelang") == 'cn' || VueCookie.get("jdcloud_sitelang") == null) {
				  if (num === this.selectedMonth) {
					return 'cur'
				  } else if (this.selectedMonth > num) {
					return 'sel'
				  } else {
					return ''
				  }
				} else if (VueCookie.get("jdcloud_sitelang") == 'en') {
				  if (num === this.selectedMonth) {
					if (this.selectedMonth == 1) {
					  return 'curSingleEn curEn';
					} else {
					  return 'curEn'
					}
				  } else if (this.selectedMonth > num) {
					return 'sel'
				  } else {
					return ''
				  }
				}
			},
			getQuota() {
				var target = this;
				Ajax.get({
					url: "/api/bm",
					action: '/getUserQuotas',
					param: {
					serviceCode: ServiceCodeConstant.CPS
					},
					success: (data) => {
					target.quotaState = 1
					target.quotaNumber = data.userQuotas[target.selectedRegion]
					},
					fail: function (data) {
					target.quotaState = -99
					}
				});
			},
			getRegion() {
				Ajax.get({
				  action: '/getRegions',
				  param: {
				  	networkType: NetworkTypeConstant.BASIC
				  },
				  success: (data) => {
					for (var i in data['regions']) {
					  var region = data['regions'][i]['region']
					  var regionName = data['regions'][i]['regionName']
					  var zones = data['regions'][i]['azs']
					  var enableIPV6 = data['regions'][i]['enableIpv6']
					  this.regions[region] = regionName
					  this.showIpv6Map[region] = enableIPV6
					  for (var j in zones) {
						var az = zones[j]['az']
						var azName = zones[j]['azName']
						if (typeof this.zones[region] == 'undefined') {
						  this.zones[region] = {}
						}
						this.zones[region][az] = azName
					  }
					}
					var passedRegion = this.$route.params.region;
					if (passedRegion != undefined) {
					  this.selectedRegion = passedRegion
					  this.selectedZone = this.regions[passedRegion]
					} else {
					  this.selectedRegion = data['regions'][0]['region']
					  this.selectedZone = data['regions'][0]['azs'][0]['az']
					}
					this.getLineTypes();
					this.getDiscountInfo();
					this.getUserType();
				  }
				});
			},
			isSkuSoldOut(isSoldOut) {
				return isSoldOut === true || isSoldOut === 'true' || isSoldOut === 1 || isSoldOut === '1';
			},
			initSelectedStandardBySeries(series) {
				const deviceTypesTableList = (this.deviceTypesTable && this.deviceTypesTable[series]) || [];
				// 历史逻辑：仅当列表首项未售罄时默认选中首项
				// if (deviceTypesTableList && !deviceTypesTableList[0]?.isSoldOut) {
				// 	this.selectedStandard = deviceTypesTableList[0]?.deviceType;
				// }
				// 新逻辑：默认选中当前系列第一个未售罄sku
				const availableSku = deviceTypesTableList.find(item => item && !this.isSkuSoldOut(item.isSoldOut));
				if (availableSku) {
					this.selectedStandard = availableSku.deviceType;
				} else {
					this.selectedStandard = '';
				}
				this.showOsTypes = !!this.selectedStandard;
			},
			getDeviceType() {
				this.deviceTypesArr = [];
				this.deviceTypesNum = [];
				Ajax.get({
					action: '/getAvailableDeviceTypes',
					param: {region: this.selectedRegion, az: this.selectedZone},
					success: (data) => {
						var deviceTypes = {}
						var deviceTypesNum = {}
						this.deviceTypesTable = data['deviceTypes']
						const seriesKeys = Object.keys(this.deviceTypesTable);
						let defaultSeries = seriesKeys[0] || '';
						this.deviceTypesTableData = deepCopy(this.deviceTypesTable[seriesKeys[0]]);
						this.deviceTypesTableData1 = deepCopy(this.deviceTypesTable[seriesKeys[1]]);
						this.deviceTypesTableData2 = deepCopy(this.deviceTypesTable[seriesKeys[2]]);
						// 历史逻辑：按 gpu -> storage -> compute 多次覆盖 selectedSeries
						// if(this.deviceTypesTableData2) {
						// 	this.deviceTypesTableData2.map((item)=>{
						// 		if(!item.isSoldOut) {
						// 			this.selectedSeries = 'gpu'
						// 		}
						// 	})
						// }
						// if(this.deviceTypesTableData1) {
						// 	this.deviceTypesTableData1.map((item)=>{
						// 		if(!item.isSoldOut) {
						// 			this.selectedSeries = 'storage'
						// 		}
						// 	})
						// }
						// if(this.deviceTypesTableData) {
						// 	this.deviceTypesTableData.map((item)=>{
						// 		if(!item.isSoldOut) {
						// 			this.selectedSeries = 'compute'
						// 		}
						// 	})
						// }
						// 新逻辑：仅计算一次默认系列（优先 compute -> storage -> gpu 的未售罄系列）
						const seriesPriority = ['compute', 'storage', 'gpu'];
						for (let i = 0; i < seriesPriority.length; i++) {
							const series = seriesPriority[i];
							const seriesList = this.deviceTypesTable[series] || [];
							if (seriesList.some(item => item && !this.isSkuSoldOut(item.isSoldOut))) {
								defaultSeries = series;
								break;
							}
						}
						for (var i in data['deviceTypes']) {
							for (var item in data['deviceTypes'][i]) {
								var nameEN = data['deviceTypes'][i][item]['deviceType']
								deviceTypes[nameEN] = data['deviceTypes'][i][item]
								this.deviceTypesArr.push(data['deviceTypes'][i][item])
								this.deviceTypesNum[nameEN] = 1
							}
						}
						for (let z = 0; z < this.deviceTypesArr.length; z++) {
							this.checkStockEnough(this.selectedRegion, this.selectedZone,
							this.deviceTypesArr[z].deviceType, this.selectedHostNumber, true)
						}
						this.deviceTypes = deviceTypes
						this.deviceTypesNum = deviceTypesNum
						// 历史逻辑（初始化阶段在getDeviceType中多分支赋值selectedStandard）已注释
						// selectedStandard 初始化统一由 selectedSeries 监听处理：
						// 默认选择“当前系列第一个未售罄sku”，避免重复赋值覆盖
						// if (this.allSold) {
						// 	// this.selectedStandard = this.deviceTypesArr[0].deviceType
						// 	this.selectedStandard = '';
						// } else {
						// 	if (this.deviceTypesArr.length > 1) {
						// 		for (var i = 0; i < this.deviceTypesArr.length; i++) {
						// 			if (this.deviceTypesNum[this.deviceTypesArr[i].deviceType]) {
						// 				this.selectedStandard = this.deviceTypesArr[i].deviceType;
						// 				break;
						// 			}
						// 		}
						// 	} else if (this.deviceTypesArr.length = 1) {
						// 		this.selectedStandard = this.deviceTypesArr[0].deviceType
						// 	}
						// }
						const oldSelectedSeries = this.selectedSeries;
						this.selectedSeries = defaultSeries;
						// 当系列值未变化时，watch(selectedSeries)不会触发，需在初始化链路兜底赋值
						if (oldSelectedSeries === defaultSeries) {
							this.initSelectedStandardBySeries(defaultSeries);
						}
					}
				});
			},
			getAvailableOS(selectedImage) {
				let param = {region: this.selectedRegion, deviceType: this.selectedStandard};
				Ajax.get('/api/cps/getAvailableOS',param).then(res => {
					const data = res.data;
					var osTypes = {}
					const imageTypes = [];
					this.customOsTypes = {}
					// 用来验证版本是不是最新的版本，将最新的版本放在最上面
					var osVersionOne = 10000
					var osVersionTwo = 10000
					let dataList = [];
					for (const i in data['oss']) {
						const image = {};
						image.source = data['oss'][i].source;
						image.sourceName = data['oss'][i].sourceName;
						imageTypes.push(image)
					}
					var obj = {};
					this.imageTypes = imageTypes.reduce(function(item, next) {
						obj[next.source] ? '' : obj[next.source] = true && item.push(next);
						return item;
					}, []);
					dataList = data['oss'].filter(item=>item.source===this.imageTypes[selectedImage].source);
					for (var i in dataList) {
						var osTypeId = dataList[i]['osTypeId']
						var osType = dataList[i]['osType']
						var osName = dataList[i]['osName']
						var osFormat = data.oss[i].format;
						if (!osTypes[osType]) {
							osTypes[osType] = []
						}

					  	if (dataList[i]['osVersion'] < osVersionOne) {
							osTypes[osType].push({osTypeId: osTypeId, osName: osName, osFormat:osFormat})

					  	} else {
							osTypes[osType].splice(0, 0, {osTypeId: osTypeId, osName: osName, osFormat: osFormat})
							osVersionOne = dataList[i]['osVersion']
					  	}
					  	if (osType !== 'Ubuntu') {
							if (this.customOsTypes[osType] === undefined) {
								this.customOsTypes[osType] = []
							}
							if (dataList[i]['osVersion'] < osVersionTwo) {
								this.customOsTypes[osType].push({osTypeId: osTypeId, osName: osName,osFormat:osFormat})
							} else {
							  	this.customOsTypes[osType].splice(0, 0, {osTypeId: osTypeId, osName: osName,osFormat:osFormat})
							  	osVersionTwo = dataList[i]['osVersion']
							}
					  	}
					}
					this.osTypes = osTypes
					this.standardOsTypes = $.extend(true, {}, this.osTypes);
					if (osTypes['CentOS']) {
						this.selectedOS = 'CentOS'
					} else {
						// this.selectedOS = dataList[0]['osType']
                        // 切换radio 筛选当前选中的镜像类型，用于默认选中第一个的操作系统 selectedImageType: 0-公共镜像，1-定制镜像，默认0
                        const selectedImageTypeData = this.imageTypes[this.selectedImageType];
                        const selectedOSData = data?.oss?.length && data.oss.find(item => {
                            return selectedImageTypeData.source === item.source;
                        });
                        // 增加容错
                        this.selectedOS = selectedOSData ? selectedOSData?.osType : dataList[0]['osType'];
					}
					if (this.selectedImageType !== 'standard_app') {
						this.osTypes = $.extend(true, {}, this.standardOsTypes);
					} else {
						this.selectedOS = 'CentOS'
						this.osTypes = $.extend(true, {}, this.customOsTypes);
					}
                    // 轮询 this.osTypes ，用于判断操作系统是否选择 --
                    // this.showOsTypes = false;
                    // for (const key in this.osTypes) {
                    //   if (this.osTypes[key] && this.osTypes[key]?.length) {
                    //        this.showOsTypes = true;
                    //    }
                    //}
				}).catch(err=>{
					if (err.message) {
						this.$message.error(err.message);
						return
					}
					const {response} = err.data;
					const json = response.json();
					this.$message.error(json.errmsg);
				})
			},

			getAvailableRaids(selectedStandard) {
				if (!selectedStandard) return;
				const param = {
					deviceType: selectedStandard,
					region: this.selectedRegion
				};
				Ajax.get('api/cps/getAvailableRaids',param).then(res =>{
					const data = res.data;
					var raids = []
					for (var i in data['raids']) {
						//系统盘raids
						if (data['raids'][i]['volumeType'] == 'system') {
							var volume1 = data['raids'][i]['volumeDetail'].split('(').join(' (');
							let sysDiskCapacity = data.raids[i].availableValue;
							// 京造服务器包含两块系统盘，分区时候只能用一个
							let systemPartitionCount = data.raids[i].systemPartitionCount;
							sysDiskCapacity = sysDiskCapacity / systemPartitionCount;
							this.calculateDiskCapacity('system',sysDiskCapacity);
							var volume = volume1.split(')');
							var raidType = ' ' + this.radisNameMap[data['raids'][i]['raidType']] + ')'
							var newRaidName = volume + raidType;
							this.selectedSysRaidName = newRaidName;
							this.selectedSysRaidTip = data['raids'][i]['description'];
							this.selectedOSRaidId = data['raids'][i]['raidTypeId'];
						} else { //数据盘raids
							if (data['raids'][i].raidType === 'NO RAID') {
								raids.splice(0, 0, data['raids'][i])
							} else {
								raids.push(data['raids'][i])
							}
						}
					}
					this.raids = raids
					//优化根据不同的机型设置默认选中的不同raid卡逻辑
					if (raids.length > 0) {
						this.selectedDataRaid = raids[raids.length - 1];
						this.resetDataPartitionModes(this.selectedDataRaid);
						this.selectedDataRaidId = this.selectedDataRaid['raidTypeId']
						let dataVolume1 = this.selectedDataRaid['volumeDetail']
						let dataVolume2 = dataVolume1.split('TB').join('TB ')
						let dataVolume = dataVolume2.split('GB').join('GB ')
						if (this.selectedDataRaid.deviceType === 'cps.s.perf1') {
							let dataRaidType = ', ' + this.customRaidsNameMap[this.selectedDataRaid['raidType']] +
							  ')'
							let tempDataRaidName = dataVolume.replace(')', dataRaidType);
							let lastIndex = tempDataRaidName.lastIndexOf(')')
							let beginString = tempDataRaidName.substring(0, lastIndex)
							var dataRaidName = beginString + ', ' + this.customRaidsNameMap['NORAID'] + ')'
						} else if (this.selectedDataRaid.deviceType === 'cps.c.perf3') {
							var dataRaidType = ', ' + this.customRaidsNameMap[this.selectedDataRaid['raidType']] + ')'
							var dataRaidName = dataVolume.replace(')', dataRaidType);
						} else {
							var dataRaidType = ', ' + this.radisNameMap[this.selectedDataRaid['raidType']] + ')'
							var dataRaidName = dataVolume.replace(')', dataRaidType);
						}
						let dataDiskCapacity = this.selectedDataRaid.availableValue;
						this.calculateDiskCapacity('data',dataDiskCapacity);
						this.selectedDataRaidName = dataRaidName
					} else {
						this.selectedDataRaidId = '';
						this.selectedDataRaidName = '--'
					}
				}).catch(err=>{
					if (err.message) {
						this.$message.error(err.message);
						return
					}
					const {response} = err.data;
					const json = response.json();
					this.$message.error(json.errmsg);
				});
			},

			// noraid数据盘分区模式特殊处理
			resetDataPartitionModes(item) {
				// 机型不支持自定义分区就不需要再对数据盘单独处理
				if (!this.deviceCustomPartitionSupport) {
					return
				}
				if (item.raidType === 'NORAID') {
					this.dataDiskPartitionModes = [
						{id:1,label:this.$t('create.text.defaultPartitionModes'),value:'default'},
					];
				} else {
					this.dataDiskPartitionModes = [
						{id:1,label:this.$t('create.text.defaultPartitionModes'),value:'default'},
						{id:2,label:this.$t('create.text.customPartitionModes'),value:'custom'},
					];
				}
				this.selectedDataDiskPartitionMode = 'default';
			},

			// 是否支持自定义分区
			resetPartitionModes(customPartitionSupport) {
				if (!customPartitionSupport) {
					this.systemDiskPartitionModes = [
						{id:1,label:this.$t('create.text.defaultPartitionModes'),value:'default'}
					];
					this.dataDiskPartitionModes = [
						{id:1,label:this.$t('create.text.defaultPartitionModes'),value:'default'}
					];
				} else {
					this.systemDiskPartitionModes = [
						{id:1,label:this.$t('create.text.defaultPartitionModes'),value:'default'},
						{id:2,label:this.$t('create.text.customPartitionModes'),value:'custom'},
					],
					this.dataDiskPartitionModes = [
						{id:1,label:this.$t('create.text.defaultPartitionModes'),value:'default'},
						{id:2,label:this.$t('create.text.customPartitionModes'),value:'custom'},
					];
				}
				this.selectedPartitionMode = 'default';
				this.selectedDataDiskPartitionMode = 'default';
			},

			getOSPartitions() {
				if (!this.selectedOSTypeId || !this.selectedRegion || !this.selectedStandard) {
					return
				}
				const param = {
			        region: this.selectedRegion,
			        deviceType: this.selectedStandard,
			        imageId: this.selectedOSTypeId
			    };
			    Ajax.get('/api/cps/getOSPartitions', param)
			    .then((res) => {
					let partitions = res.data.partitions;
					this.handleSystemPartitions(partitions);
					this.handleDataPartitions(partitions);
			    }).catch(async (err)=>{
			    	const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
			    });
			},

			dealRemainSystemDataPartitions(diskSize,diskPartitions) {
				return diskSize - diskPartitions.filter(item => item.size !== 999999999).reduce((init,current) => {
					return init + current.size
				},0);
			},

			dealDefaultPartitions(partitions) {
				let defaultPartitions = deepCopy(partitions);
				defaultPartitions.map((item) => {
					item.size = item.isRemainDataPartition ? this.$t('retailInstance.text.allRemainingSpace') : `${item.size}GiB`;
				});

				return defaultPartitions.reduce((init,current) =>{
					return `${init}<strong class="ml5 mr5">${current.point}:</strong><span>${current.size},${current.format};</span>`
				},'')
			},

			handlePartitions(remainPartitions, diskPartitions, type) {
				let hasRemainDataPartition = false;
				let systemDataPartitions = diskPartitions.map(item=>{
					item.isEditing = false;
					if (item.size === 999999999) {
						item.size = remainPartitions;
						item.isRemainDataPartition = true;
						hasRemainDataPartition = true;
					}
					item.size = item.size / 1024;
					return item
				});

				if (type === 'systemDisk') {
					this.defaultSystemDataPartitions = this.dealDefaultPartitions(systemDataPartitions);
				} else if (type === 'dataDisk'){
					this.defaultDataDiskPartitions = this.dealDefaultPartitions(systemDataPartitions);
				}
				systemDataPartitions.push({
					point: this.$t('retailInstance.text.emptyPartition'),
					isEditing: false,
					size: hasRemainDataPartition ? 0 : parseInt(remainPartitions / 1024,10) ,
					format: this.isCentOS66 ? 'ext3' : 'xfs',
					isNoPartition: true
				});
				systemDataPartitions.map(item => {
					if (item.point === '/') {
						item.minSize = 5;
					} else if (item.point === '/boot') {
						item.minSize = 1;
					} else {
						item.minSize = 0;
					}
					item.maxSize = item.size + (hasRemainDataPartition ? 0 : parseInt(remainPartitions / 1024,10))
					return item
				});
				return systemDataPartitions
			},

			handleSystemPartitions(partitions) {
				let remainSystemDataPartitions =  this.dealRemainSystemDataPartitions(this.systemDiskSize*1024, partitions.systemDiskPartitions);
				this.systemDataPartitions = this.handlePartitions(remainSystemDataPartitions, partitions.systemDiskPartitions, 'systemDisk');
			},

			handleDataPartitions(partitions) {
				let remainSystemDataPartitions =  this.dealRemainSystemDataPartitions(this.dataDiskSize*1024, partitions.dataDiskPartitions);
				this.dataDiskPartitions = this.handlePartitions(remainSystemDataPartitions, partitions.dataDiskPartitions, 'dataDisk');
			},
			resetDiskCapacity(type) {
				if (!this.selectedOSTypeId || !this.selectedRegion || !this.selectedStandard) {
					return
				}
				const param = {
			        region: this.selectedRegion,
			        deviceType: this.selectedStandard,
			        imageId: this.selectedOSTypeId
			    };
			    Ajax.get('/api/cps/getOSPartitions', param)
			    .then((res) => {
					let partitions = res.data.partitions;
					if (type === 'system') {
						this.handleSystemPartitions(partitions);
					} else if(type === 'data') {
						this.handleDataPartitions(partitions);
					}
			    }).catch(async (err)=>{
			    	const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
			    });
			},
			calculateDiskCapacity(type, capacity) {
				let diskCapacity = Math.floor(capacity * 0.93);
				if (type === 'system') {
					this.sysDiskCapacity =  diskCapacity + 'GiB';
					this.systemDiskSize = diskCapacity;
				} else if (type === 'data') {
					this.dataDiskCapacity = diskCapacity + 'GiB';
					this.dataDiskSize = diskCapacity;
				}
			},
			getSubnet() {
				this.hasSubNet = false;
				Ajax.get({
				  action: '/getSubnet',
				  param: {region: this.selectedRegion, az: this.selectedZone},
				  success: (data) => {
					var cidrArr = ['*', '*', '*', '*']
					if (data['subnet'] != undefined) {
					  var arr = data['subnet']['cidr'].split("/")
					  var mask = arr[1]
					  var network = arr[0]
					  if (network) {
						cidrArr = network.split('.')
					  }
					  this.selectedNetworkFirst = cidrArr[0]
					  this.selectedMask = mask
					  this.cidrArr = cidrArr
					  this.cidr1Val = cidrArr[0];
					  this.cidr2Val = cidrArr[1];
					  this.cidr3Val = cidrArr[2];
					  this.cidr4Val = cidrArr[3];
					  this.hasSubNet = true;
					  this.selectedCidr = data['subnet']['cidr']
					}
				  }
				});
			},
			checkStockEnough(region, az, selectedStandard, selectedHostNumber, init) {
				// init 用来区分是不是初始化,不是初始化,则不用传值,是初始化则传true
				if (!region || !az || !selectedStandard) {
				  return
				}
				var param = {
				  region: region,
				  az: az,
				  deviceType: selectedStandard,
				  count: selectedHostNumber
				}
				Ajax.get({
				  url: '/api/bm',
				  action: '/isStockEnough',
				  param: param,
				  success: (data) => {
					this.deviceTypesNum[selectedStandard] = data
					var newDeviceTypesNum = $.extend(true, {}, this.deviceTypesNum)
					this.deviceTypesNum = $.extend(true, {}, newDeviceTypesNum)
					if (init) {
					  this.cacheDeviceTypesNum[selectedStandard] = data
					  var cacheDeviceTypesNum = $.extend(true, {}, this.cacheDeviceTypesNum)
					  this.cacheDeviceTypesNum = $.extend(true, {}, cacheDeviceTypesNum)
					  this.cacheDeviceTypesNum[''] = false
					  for (let z = 0; z < this.deviceTypesArr.length; z++) {
						var name = this.deviceTypesArr[z]['deviceType']
						this.allSold = this.allSold && (this.deviceTypesNum[name] != undefined || this.deviceTypesNum[name] != false);
					  }
					  // 历史逻辑（初始化库存回调中循环赋值selectedStandard）已注释，避免重复赋值覆盖当前系列默认值
					  // for (let z = 0; z < this.deviceTypesArr.length; z++) {
					  // 	var name = this.deviceTypesArr[z]['deviceType']
					  // 	this.allSold = this.allSold && (this.deviceTypesNum[name] != undefined || this.deviceTypesNum[name] != false);
					  // 	if (this.deviceTypesNum[name]) {
					  // 		this.selectedStandard = name;
					  // 		break
					  // 	}
					  // }
					}
					if (this.deviceTypesNum[this.selectedStandard] !== undefined) {
					  this.isStockEnough = this.deviceTypesNum[this.selectedStandard]
					}
				  }
				});
			},
			calculateTotalPrice() {
				if (!this.selectedRegion || !this.selectedStandard || isEmptyObject(this.discountedInfo)){
				  return ''
				}
				this.isCalculatIng = true;
				this.discountedTotalPrice = this.$t('create.text.calculating')
				this.discountedServerPrice = this.$t('create.text.calculating');
				this.discountedEipPrice = this.$t('create.text.calculating');
				this.totalPrice = this.$t('create.text.calculating')
				this.totalDiscount = this.$t('create.text.calculating')
				var param = {
					cmd: 1,//创建
					region: this.selectedRegion,
					timeUnit: this.timeUnit,//月
					timeSpan: this.timeUnit == 3 ? this.selectedMonth : this.selectedYear,
					bw: this.radioIp ? this.selectedMaxBandwidth : 0,
					count: this.selectedHostNumber,
					deviceType: this.selectedStandard,
					createType: CreateTypeConstant.BASIC
				}
				// 如果非整数，不计算价格
				if(!/^\d+$/.test(this.selectedHostNumber)){
				  return false;
				}
				Ajax.get('/api/price/calculateTotalPrice',param).then(res => {
          const { discountedTotalPrice, totalPrice, totalDiscount, list } = res?.data || {};
					this.discountedTotalPrice = changeTwoDecimal(divDecimals(discountedTotalPrice, this.selectedMonth));
					let priceSnapShot = JSON.parse(list.length && list[0] ? list[0]?.priceSnapShot : '{}');
					let eipPrice = this.radioIp && this.calculatingEipPrice(priceSnapShot,ChargeModeConstant.PREPAID_BY_DURATION);
					// this.discountedEipPrice = changeTwoDecimal(eipPrice * this.selectedHostNumber * this.selectedMonth * this.discountedInfo[this.selectedMonth]);
					this.discountedEipPrice = changeTwoDecimal(mulDecimals(mulDecimals(mulDecimals(eipPrice, this.selectedHostNumber), this.selectedMonth), this.discountedInfo[this.selectedMonth]));
					let devicePrice = this.calculatingServerPrice(priceSnapShot);
					// this.discountedServerPrice = changeTwoDecimal(devicePrice * this.selectedHostNumber * this.selectedMonth * this.discountedInfo[this.selectedMonth]);
					this.discountedServerPrice = changeTwoDecimal(mulDecimals(mulDecimals(mulDecimals(devicePrice, this.selectedHostNumber), this.selectedMonth), this.discountedInfo[this.selectedMonth]));
					this.totalPrice = changeTwoDecimal(totalPrice);
					this.totalDiscount = changeTwoDecimal(totalDiscount);
          this.favorablePricePerHour = totalDiscount ? changeTwoDecimal(subDecimals(totalPrice, discountedTotalPrice)) : '--';
				}).catch(() => {
                    this.clearPrice();
                }).finally(() => {
					this.isCalculatIng = false;
				});
				return ''
			},
			configurationsCalculateTotalPrice() {
				if (!this.selectedRegion || !this.selectedStandard) {
				  return ''
				}
				this.isConfigurationsCalculatIng = true;
				this.configurationsTotalPrice = this.$t('create.text.calculating');
				this.discountByConfigurationsOneMonthPrice = this.$t('create.text.calculating');
				this.discountByConfigurationsServerPrice = this.$t('create.text.calculating');
				this.discountByConfigurationsEipPrice = this.$t('create.text.calculating');
				var param = {
					cmd: 1,//创建
					region: this.selectedRegion,
					bw: this.radioIp ? this.selectedMaxBandwidth : 0,
					count: this.selectedHostNumber,
					deviceType: this.selectedStandard,
					createType: CreateTypeConstant.BASIC,
					billingType: BillingTypesConstant.POSTPAID_BY_DURATION
				}
				// 如果非整数，不计算价格
				if(!/^\d+$/.test(this.selectedHostNumber)){
					return false;
				}
				Ajax.get('/api/price/calculateTotalPrice',param).then(res => {
          const { discountedTotalPrice, totalPrice, totalDiscount, list } = res?.data || {};
					let priceSnapShot =JSON.parse(list.length && list[0] ? list[0]?.priceSnapShot : '{}');
					let eipPrice = this.radioIp && this.calculatingEipPrice(priceSnapShot,ChargeModeConstant.POSTPAID_BY_DURATION);
					this.discountByConfigurationsEipPrice = changeTwoDecimal(eipPrice);
					let devicePrice = this.calculatingServerPrice(priceSnapShot);
					this.discountByConfigurationsServerPrice = changeTwoDecimal(devicePrice);
					this.configurationsTotalPrice = changeTwoDecimal(totalPrice);
					this.configurationsTotalDiscount = totalDiscount ? changeTwoDecimal(subDecimals(totalPrice, discountedTotalPrice)) : '--';
					this.discountByConfigurationsOneMonthPrice= changeTwoDecimal(mulDecimals(mulDecimals(discountedTotalPrice, 24), 30));
				}).catch(() => {
                    this.clearPrice();
                }).finally(() => {
					this.isConfigurationsCalculatIng = false;
				});
				return ''
			},
			calculatingServerPrice(priceSnapShot) {
				return priceSnapShot[this.selectedStandard];
			},

			calculatingEipPrice(priceSnapShot, chargeMode) {
				let eipPriceRe = /^bw\.\d$/;
				let eipPrices = Object.keys(priceSnapShot).sort().filter(item => eipPriceRe.test(item)).map(item => {
					return priceSnapShot[item]
				});
				function getEipPrice(bandwidth, chargeMode) {
					if (bandwidth >= eipPrices.length) {
						return chargeMode === ChargeModeConstant.PREPAID_BY_DURATION ? (125+(bandwidth - (eipPrices.length-1))*80) : (0.22+(bandwidth - (eipPrices.length-1))*0.14);
					}
					return eipPrices.reduce((init,curr,index,arr) => {
						if (index < bandwidth) {
							return init + curr
						}
						else {
							return init + 0
						}
					},0)
				}
				let bandwidth = this.selectedMaxBandwidth;
				return getEipPrice(bandwidth,chargeMode);
			},
			calSelectedMaxBandwidth() {
				this.selectedMaxBandwidth = this.tmpMaxBandwidth
			},
			selectStandard(standard) {
				if (!this.deviceTypesNum[standard]) {
				  return
				}
				this.selectedStandard = standard
				this.selectedApplication = []
			},
			selectApplication(name) {
				for (var i in this.selectedApplication) {
					if (name == this.selectedApplication[i]['name']) {
						this.selectedApplication.splice(i, 1);
						return
					}
				}
				var arr = []
				for (var i in this.applications) {
					if (name == this.applications[i]['name']) {
						this.selectedApplication.push({name: name, version: this.applications[i]['version']})
						return
					}
				}
			},
			selectDataRaid(item) {
				this.resetDataPartitionModes(item);
				this.selectedDataRaid = item;
				this.selectedDataRaidId = item.raidTypeId;
				let dataVolume1 = item['volumeDetail']
				let dataVolume2 = dataVolume1.split('TB').join('TB ')
				let dataVolume = dataVolume2.split('GB').join('GB ')
				if (item.deviceType === 'cps.s.perf1') {
				  let dataRaidType = ', ' + this.customRaidsNameMap[item['raidType']] +
					')'
				  let tempDataRaidName = dataVolume.replace(')', dataRaidType);
				  let lastIndex = tempDataRaidName.lastIndexOf(')')
				  let beginString = tempDataRaidName.substring(0, lastIndex)
				  var dataRaidName = beginString + ', ' + this.customRaidsNameMap['NORAID'] + ')'
				}else if (item.deviceType === 'cps.c.perf3') {
				  var dataRaidType = ', ' + this.customRaidsNameMap[item['raidType']] + ')'
				  var dataRaidName = dataVolume.replace(')', dataRaidType);
				} else {
				  var dataRaidType = ', ' + this.radisNameMap[item['raidType']] + ')'
				  var dataRaidName = dataVolume.replace(')', dataRaidType);
				}
				let dataDiskCapacity = item.availableValue;
				this.calculateDiskCapacity('data',dataDiskCapacity);
				// 重置数据盘
				this.resetDiskCapacity('data');
				this.selectedDataRaidName = dataRaidName
			},
			selectMonth(selMonth) {
				this.chargeUnit = 3;
				this.timeUnit = 3;
				this.selectedMonth = selMonth
				this.otherMonth = selMonth
				switch (selMonth) {
				  case 12:
					this.cutMonth = 2;
					break;
				  case 24:
					this.cutMonth = 4;
					break;
				  case 36:
					this.cutMonth = 6;
					break;
				  default:
					this.cutMonth = 0;
				}
			},
			selectYear(selYear) {
				switch (selYear) {
				  case 1:
					this.selectedMonth = 12;
					break;
				  case 2:
					this.selectedMonth = 24;
					break;
				  case 3:
					this.selectedMonth = 36;
					break;
				  default:
					this.cutMonth = 0;
				}
				this.selectedYear = selYear;
				this.chargeUnit = 4;
				this.timeUnit = 4;
			},
			jump_to_up() {
				this.$router.push({
					name: 'List',
					params: {region: this.selectedRegion}
				});
			},
			buy() {
				var formValid = true;
				this.$refs['ruleFormType'].validate((valid) => {
				  formValid = valid
				});
				if (!formValid) {
				  if (this.$refs['application'] !== undefined) {
					this.ruleFormTag.application = this.$refs['application'].validateState
				  }
				  $(".mainCon").scrollTop($(".mainCon").scrollTop() + $('#imgType').offset().top - $(".mainCon").offset().top - 100);
				  return false;
				}

				// 校验系统盘及数据盘自定义分区模式下是否保存
				if(this.$refs.systemPartition && this.$refs.systemPartition.isRowNotSaved) {
					$('.mainCon').scrollTop($('.mainCon').scrollTop() + $('#storage').offset().top - $('.mainCon').offset().top - 100);
						return false;
				}
				if(this.$refs.dataPartition && this.$refs.dataPartition.isRowNotSaved) {
					$('.mainCon').scrollTop($('.mainCon').scrollTop() + $('#storage').offset().top - $('.mainCon').offset().top - 100);
					return false;
				}
				if (typeof this.$refs.advancedCustomData !== 'undefined') {
					this.$refs.advancedCustomData.$refs.advanced.validate((valid) => {
						formValid = valid;
					});
					if (!formValid) {
						$('.mainCon').scrollTop($('.mainCon').scrollTop() + $('#advanced').offset().top - $('.mainCon').offset().top - 100);
						return false;
					}
				}
				this.$refs.tagForm.validate((valid) => {
					formValid = valid;
				});
				if (!formValid) {
					$('.mainCon').scrollTop($('.mainCon').scrollTop() + $('#advanced').offset().top - $('.mainCon').offset().top - 100);
					return false;
				}
				this.$refs['ruleForm'].validate((valid) => {
				  formValid = valid
				});

				if (this.cidr2ValueNotInRange || this.cidr3ValueNotInRange || this.cidr4ValueNotInRange) {
					  if (this.cidr2ValueNotInRange) {
					  }
					  if (this.cidr3ValueNotInRange) {
					  }
					  if (this.cidr4ValueNotInRange) {
					  }
					$(".mainCon").scrollTop($(".mainCon").scrollTop() + $('#CIDR').offset().top - $(".mainCon").offset().top - 100);
					return false;
				}

				if (!formValid&&this.passwordType ==="custom") {
				  this.ruleFormTag.hostName = this.$refs['hostName'].validateState
				  this.ruleFormTag.hostDesc = this.$refs['hostDesc'].validateState
				  this.ruleFormTag.hostPwd = this.$refs['hostPwd'].validateState
				  this.ruleFormTag.hostConfirmPwd = this.$refs['hostConfirmPwd'].validateState
				  this.ruleFormTag.mainName = this.$refs['mainName'].validateState

				  $(".mainCon").scrollTop($(".mainCon").scrollTop() + $('#baseInfo').offset().top - $(".mainCon").offset().top - 100);
				  return false;
				}

				if (!formValid&&(this.passwordType ==="key"||this.passwordType ==="auto")) {
				  this.ruleFormTag.hostName = this.$refs['hostName'].validateState
				  this.ruleFormTag.hostDesc = this.$refs['hostDesc'].validateState
				  this.ruleFormTag.mainName = this.$refs['mainName'].validateState

				  $(".mainCon").scrollTop($(".mainCon").scrollTop() + $('#baseInfo').offset().top - $(".mainCon").offset().top - 100);
				  return false;
				}
				var param = {
				  region: this.selectedRegion,
				  az: this.selectedZone,
				  deviceType: this.selectedStandard,
				  count: this.selectedHostNumber
				}
				Ajax.get({
					url: '/api/bm',
					action: '/isStockEnough',
					param: param,
					success: (data) => {
						if (data == true) {
						  this.isStockEnough = true
						  this.createOrder()
						} else {
						  this.isStockEnough = false
						}
					}
				});
			},
		  	createOrder() {
				let selectedDeviceData = this.deviceTypes[this.selectedStandard];
				let selectedDeviceName = selectedDeviceData.deviceType;
				let systemDiskPartitions = this.systemDataPartitions.filter(item => !item.isNoPartition).map(item => {
					return {
						"size": item.size,
	                    "format": item.format,
	                    "point": item.point
					}
				});
				if (this.selectedPartitionMode === 'default') {
					systemDiskPartitions = [];
				}
				let dataDiskPartitions = this.dataDiskPartitions.filter(item => !item.isNoPartition).map(item => {
					return {
						"size": item.size,
	                    "format": item.format,
	                    "point": item.point
					}
				});
				if (this.selectedDataDiskPartitionMode === 'default') {
					dataDiskPartitions = [];
				}
				let subnet = this.cidr1Val + '.' + this.cidr2Val + '.' + this.cidr3Val + '.' + this.cidr4Val + '/';
				if (!this.hasSubNet) {
				  	this.selectedCidr = subnet + this.cidr5Val;
				} else {
				  	this.selectedCidr = subnet + this.selectedMask;
				}
				var arr = []
				for (let z = 0; z < this.selectedApplication.length; z++) {
				  	arr.push({
						name: this.selectedApplication[z].name,
						version: this.selectedApplication[z].version
				  	})
				}
				var param = {
					orderType: 1, //新购
					region: this.selectedRegion,
					az: this.selectedZone,
					deviceType: this.selectedStandard,
					imageType: 'standard',//镜像类型
					osTypeId: this.selectedOSTypeId,
					sysRaidTypeId: this.selectedOSRaidId,//系统盘raid
					systemDiskPartitions,
					dataRaidTypeId: this.selectedDataRaidId,//数据盘raid
					dataDiskPartitions,
					name: this.ruleForm.hostName,
					description: this.ruleForm.hostDesc,
					softwares: arr,
					cidr: this.selectedCidr,
					lineType: this.selectedLineType,
					bw: this.radioIp ? this.selectedMaxBandwidth : 0,
					chargeMode: this.currentMode === 'tab1' ? 3:1,//计费类型 1.按配置 3.包年包月
					chargeDuration: this.chargeUnit == 3 ? this.selectedMonth : this.selectedYear,
					chargeUnit: this.chargeUnit, //月 计费时长单位 1:小时 2:天 3:月 4:年
					quantity: this.selectedHostNumber,
					sysRaidName: this.selectedSysRaidName,
					dataRaidName: this.selectedDataRaidName,
					imageName: this.selectedOSName,
					deviceName: selectedDeviceName,
					clientToken: this.clientToken,
					timestamps: this.clientToken,
					hostname: this.ruleForm.mainName,
					createType: CreateTypeConstant.BASIC,
					autoRenew: this.autoRenew,
					userData: this.advancedSetting ? this.userData : undefined, // 高级设置的脚本
					resourceTags: this.tagForm.tags,
				}
				// 密钥登陆参数处理
				if (this.passwordType === 'custom') {
				  	param.loginType = 'pwd';
				  	param.password = this.ruleForm.hostPwd;
				  	if(this.setKeyState){
						param.keypairIdSos = this.ruleForm.selectKey;
					}
				} else if (this.passwordType === 'key') {
				  	param.loginType = 'keyPair';
				  	param.password = '';
				  	param.keyPairId = this.ruleForm.selectKey;
				  	param.keypairIdSos = this.ruleForm.sosKey;
				} else {
				  	param.loginType = 'autoPwd';
				  	if(this.setKeyState){
						param.keypairIdSos = this.ruleForm.selectKey;
					}
				}
				//北京不支持ipv6，一直传no
				if (this.showIpv6Map[this.selectedRegion] === 'yes') {
				  param.enableIpv6 = this.ipV6 ? 'yes' : 'no';
				} else {
				  param.enableIpv6 = 'no';
				}

				Ajax.post('/api/cps/instances/createInstance', param, {
					headers: {
						'Content-Type': 'application/json'
					}
				}).then((res) => {
					const orderId = res.data['tempOrderNumber'];
					if(orderId !== '' && orderId !== undefined){
						window.location.href = `${this.Config.ORDER_URL}/confirm?buyId=${orderId}&source=1`;
					}
				})
				.catch(async (err) => {
					const {response} = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				})
			},
			setTab(name, cursel, n) {
				// this.setSelectedShow(cursel);
				for (var i = 1; i <= n; i++) {
					var menu = document.getElementById(name + i);
					var con = document.getElementById("con-" + name + "-" + i);
					menu.className = i == cursel ? "hover" : "";
					// con.style.display = i == cursel ? "block" : "none";
				}
				this.currentMode = name + cursel;
			},
			setSelectedShow(cursel) {
				let sel = document.getElementById("selected");
				if (cursel > 1) {
					sel.style.display = 'none';
				} else {
					sel.style.display = 'block';
				}
			},
			getDataRaidName() {
			},
			focusCidrVal(val, cidrType, availableDataList) {
				let changeVal = val;
				if (isNaN(val)) {
					changeVal = availableDataList[0];
				} else {
					changeVal = parseInt(val);
				}
				switch (cidrType) {
				  case 'cidr2':
					if (availableDataList.indexOf(changeVal) == -1) {
						this.cidr2ValueNotInRange = true;
					}
					break;
				  case 'cidr3':
					if (availableDataList.indexOf(changeVal) == -1) {
						this.cidr3ValueNotInRange = true;
					}
					break;
				  case 'cidr4':
					if (availableDataList.indexOf(changeVal) == -1) {
						this.cidr4ValueNotInRange = true;
					}
					break;
				}
			},
		  /**
		   * 校验cidr的值
		   * @param val                   校验的值
		   * @param cidrType              校验的cidr的位置
		   * @param availableDataList     校验cidr所允许的范围
		   */
		  // blurCidrVal(val, cidrType, availableDataList) {
		  //   let changeVal = val;
		  //   if (isNaN(val)) {
		  //     changeVal = availableDataList[0];
		  //   } else {
		  //     changeVal = parseInt(val);
		  //   }
		  //   let theIndex = 0;
		  //   let minAbs = changeVal;
		  //   for (let i = 0; i < availableDataList.length; i++) {
		  //     if (Math.abs(changeVal - availableDataList[i]) <= minAbs) {
		  //       minAbs = Math.abs(changeVal - availableDataList[i]);
		  //       theIndex = i;
		  //     }
		  //   }
		  //   changeVal = availableDataList[theIndex];
		  //   switch (cidrType) {
		  //     case 'cidr2':
		  //       this.cidr2Val = changeVal;
		  //       if(availableDataList.indexOf(changeVal) != -1){
		  //         this.cidr2ValueNotInRange = false;
		  //       }
		  //     case 'cidr3':
		  //       this.cidr3Val = changeVal;
		  //       if(availableDataList.indexOf(changeVal) != -1){
		  //         this.cidr3ValueNotInRange = false;
		  //       }
		  //     case 'cidr4':
		  //       this.cidr4Val = changeVal;
		  //       if(availableDataList.indexOf(changeVal) != -1){
		  //         this.cidr4ValueNotInRange = false;
		  //       }
		  //       break;
		  //   }
		  // },
			blurCidr2Val(val, availableDataList) {
				let changeVal = val;
				if (val == '') {
				  changeVal = availableDataList[0];
				} else {
				  changeVal = parseInt(val);
				}
				this.cidr2Val = changeVal;
				if (availableDataList.indexOf(changeVal) != -1) {
				  this.cidr2ValueNotInRange = false;
				} else {
				  this.cidr2ValueNotInRange = true;
				}
			},
			blurCidr3Val(val, availableDataList) {
				let changeVal = val;
				if (val == '') {
				  changeVal = availableDataList[0];
				} else {
				  changeVal = parseInt(val);
				}
				this.cidr3Val = changeVal;
				if (availableDataList.indexOf(changeVal) != -1) {
				  this.cidr3ValueNotInRange = false;
				} else {
				  this.cidr3ValueNotInRange = true;
				}
			},
			blurCidr4Val(val, availableDataList) {
				let changeVal = val;
				if (val == '') {
				  changeVal = availableDataList[0];
				} else {
				  changeVal = parseInt(val);
				}
				this.cidr4Val = changeVal;
				if (availableDataList.indexOf(changeVal) != -1) {
				  this.cidr4ValueNotInRange = false;
				} else {
				  this.cidr4ValueNotInRange = true;
				}
			},

			//改变cidr第一块
			changeCidr1() {
				if (!this.hasSubNet) {
					this.selectCidrMapOption = cidrList.cidrOption[this.cidr1Val][this.cidr5Val];
					this.cidr2ValueNotInRange = false;
					this.cidr2ValueNotInRange = false;
					this.cidr3ValueNotInRange = false;
					this.cidr4ValueNotInRange = false;
					this.cidr2Val = this.selectCidrMapOption.secondVal;
					this.cidr3Val = this.selectCidrMapOption.thirdVal;
					this.cidr4Val = this.selectCidrMapOption.fourthVal;
				}
			},
			//改变cidr最后一块
			changeCidr5() {
				if (!this.hasSubNet) {
					var setCIdr4 = [17, 18, 19, 20, 21, 22, 23, 24];
					this.selectCidrMapOption = cidrList.cidrOption[this.cidr1Val][this.cidr5Val];
					this.cidr2ValueNotInRange = false;
					this.cidr3ValueNotInRange = false;
					this.cidr4ValueNotInRange = false;
					this.tip2Focus = false;
					this.tip3Focus = false;
					this.tip4Focus = false;
					if (this.cidr5Val == 16) {
						this.cidr3Val = this.selectCidrMapOption.thirdVal;
						this.cidr4Val = this.selectCidrMapOption.fourthVal;
						this.focusCidrVal(this.cidr2Val, 'cidr2', this.selectCidrMapOption.availableData2)
					} else if (setCIdr4.indexOf(this.cidr5Val) != -1) {
						this.cidr4Val = this.selectCidrMapOption.fourthVal;
						this.focusCidrVal(this.cidr2Val, 'cidr2', this.selectCidrMapOption.availableData2)
						this.focusCidrVal(this.cidr3Val, 'cidr3', this.selectCidrMapOption.availableData3)
					} else {
						this.focusCidrVal(this.cidr2Val, 'cidr2', this.selectCidrMapOption.availableData2)
						this.focusCidrVal(this.cidr3Val, 'cidr3', this.selectCidrMapOption.availableData3)
						this.focusCidrVal(this.cidr4Val, 'cidr4', this.selectCidrMapOption.availableData4)
					}
				}
			},
			doClose() {
				this.dialogVisible = false;
				this.bandWidthArea = true;
				this.radioIp = true;
				this.selectedFirewall = 1;
			},
			doConfirm() {
				// this.$message.success(this.$t('privateNetInstance.operateSuccess'));
				this.dialogVisible = false;
				this.radioIp = false;
				this.bandWidthArea = false;
				this.ipV6 = false;
			},
			getCurrentSeries(selectedStandard) {
				let allSeries = this.deviceTypesTable;
				for (var item in allSeries) {
					for (var deviceItem in allSeries[item]) {
						if (allSeries[item][deviceItem].deviceType === selectedStandard) {
							this.selectedSeries = item;
						}
					}
				}
			},
			//机型表格第一列英文时折行显示处理
			isIncludeBra(value) {
				if (value.includes('(') && value.includes('generation')) {
					return value.replace('(', '<br>(');
				} else if (value.includes('（') && value.includes('generation')) {
					return value.replace('（', '<br>（');
				} else {
					return value;
				}
			},
			//获取折扣信息
			getDiscountInfo() {
				const param = {
				  serviceCode: ServiceCodeConstant.CPS,
				  billType: 2, //包年包月
				  billPeriod: '1,2,3',
				  timeUnit: 4, //年
				  region: this.selectedRegion,
				  buyType: 1//1、新购2、续费3、配置变更
				}
				Ajax.get({
					url: '/api/discount',
					action: '/describeLowestDiscount',
					param,
					success: (data) => {
						if (data.length > 0) {
							for (let i = 0; i < data.length; i++) {
								this.allDiscountedInfo[i]['message'][0] = data[i].discounts[0].message;
							}
							this.discountedInfo = data.reduce((init,current) => {
								let billPeriod = current.billPeriod;
								init[billPeriod] = current.discounts[0].discount / 100
								return init
							},{});
							/*修复默认进入页面后此接口返回值在calculateTotalPrice接口发返回值之后的费用信息展示问题*/
							this.calculateTotalPrice();
						}
					}
				});
			},

			// 添加标签错误处理
			errorHandler(err) {
				console.log(err)
			}
		}
	}
</script>

<style lang="scss">
	@import '../../../assets/scss/createCommon';
	@import '../../../assets/scss/selectedConfigure';
	@import '../../../assets/scss/sliderCommon';
	@import 'style';
	.create-container {
		.search-input {
			width: 200px !important;
			margin: 5px;
		}

		.search-icon {
			margin: 5px;
		}

		.search-label {
			padding-top: 10px;
		}

		.select-type {
			display: flex;
			flex-direction:row;
			justify-content:flex-start;
			margin-left: 130px;
			border-left: 1px solid #dbe3e9;
			border-right: 1px solid #dbe3e9;
			border-top: 1px solid #dbe3e9;
			padding: 5px 5px 5px 10px;

		}
		.defaultPartition {
			span {
				color: #9e9e9e;
			}
		}
	}
</style>

<style lang="scss" scoped>
	.price {
		font-size: 22px !important;
	}
</style>



// WEBPACK FOOTER //
// src/views/basicInstance/create/CreateCase.vue